var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _linearGradient74, _linearGradient75, _linearGradient76, _linearGradient77, _linearGradient78, _linearGradient79, _linearGradient80, _linearGradient81, _linearGradient82, _linearGradient83, _linearGradient84, _linearGradient85, _linearGradient86, _linearGradient87, _linearGradient88, _linearGradient89, _linearGradient90, _linearGradient91, _linearGradient92, _linearGradient93, _linearGradient94, _linearGradient95, _linearGradient96, _linearGradient97, _linearGradient98, _linearGradient99, _linearGradient100, _linearGradient101, _linearGradient102, _linearGradient103, _linearGradient104, _linearGradient105, _linearGradient106, _linearGradient107, _linearGradient108, _linearGradient109, _linearGradient110, _linearGradient111, _linearGradient112, _linearGradient113, _linearGradient114, _linearGradient115, _linearGradient116, _linearGradient117, _linearGradient118, _linearGradient119, _linearGradient120, _linearGradient121, _linearGradient122, _linearGradient123, _linearGradient124, _linearGradient125, _linearGradient126, _linearGradient127, _linearGradient128, _linearGradient129, _linearGradient130, _linearGradient131, _linearGradient132, _linearGradient133, _linearGradient134, _linearGradient135, _linearGradient136, _linearGradient137, _linearGradient138, _linearGradient139, _linearGradient140, _linearGradient141, _linearGradient142, _linearGradient143, _linearGradient144, _linearGradient145, _linearGradient146, _linearGradient147, _linearGradient148, _linearGradient149, _linearGradient150, _linearGradient151, _linearGradient152, _linearGradient153, _linearGradient154, _linearGradient155, _linearGradient156, _linearGradient157, _linearGradient158, _linearGradient159, _linearGradient160, _linearGradient161, _linearGradient162, _linearGradient163, _linearGradient164, _linearGradient165, _linearGradient166, _linearGradient167, _linearGradient168, _linearGradient169, _linearGradient170, _linearGradient171, _linearGradient172, _linearGradient173, _linearGradient174, _linearGradient175, _linearGradient176, _linearGradient177, _linearGradient178, _linearGradient179, _linearGradient180, _linearGradient181, _linearGradient182, _linearGradient183, _linearGradient184, _linearGradient185, _linearGradient186, _linearGradient187, _linearGradient188, _linearGradient189, _linearGradient190, _linearGradient191, _linearGradient192, _linearGradient193, _linearGradient194, _linearGradient195, _linearGradient196, _linearGradient197, _linearGradient198, _linearGradient199, _linearGradient200, _linearGradient201, _linearGradient202, _linearGradient203, _linearGradient204, _linearGradient205, _linearGradient206, _linearGradient207, _linearGradient208, _linearGradient209, _linearGradient210, _linearGradient211, _linearGradient212, _linearGradient213, _linearGradient214, _linearGradient215, _linearGradient216, _linearGradient217, _linearGradient218, _linearGradient219, _linearGradient220, _linearGradient221, _linearGradient222, _linearGradient223, _linearGradient224, _linearGradient225, _linearGradient226, _linearGradient227, _linearGradient228, _linearGradient229, _linearGradient230, _linearGradient231, _linearGradient232, _linearGradient233, _linearGradient234, _linearGradient235, _linearGradient236, _linearGradient237, _linearGradient238, _linearGradient239, _linearGradient240, _linearGradient241, _linearGradient242, _linearGradient243, _linearGradient244, _linearGradient245, _linearGradient246, _linearGradient247, _linearGradient248, _linearGradient249, _linearGradient250, _linearGradient251, _linearGradient252, _linearGradient253, _linearGradient254, _linearGradient255, _linearGradient256, _linearGradient257, _linearGradient258, _linearGradient259, _linearGradient260, _linearGradient261, _linearGradient262, _linearGradient263, _linearGradient264, _linearGradient265, _linearGradient266, _linearGradient267, _linearGradient268, _linearGradient269, _linearGradient270, _linearGradient271, _linearGradient272, _linearGradient273, _linearGradient274, _linearGradient275, _linearGradient276, _linearGradient277, _linearGradient278, _linearGradient279, _linearGradient280, _linearGradient281, _linearGradient282, _linearGradient283, _linearGradient284, _linearGradient285, _linearGradient286, _linearGradient287, _linearGradient288, _linearGradient289, _linearGradient290, _linearGradient291, _linearGradient292, _linearGradient293, _linearGradient294, _linearGradient295, _linearGradient296, _linearGradient297, _linearGradient298, _linearGradient299, _linearGradient300, _linearGradient301, _linearGradient302, _linearGradient303, _linearGradient304, _linearGradient305, _linearGradient306, _linearGradient307, _linearGradient308, _linearGradient309, _linearGradient310, _linearGradient311, _linearGradient312, _linearGradient313, _linearGradient314, _linearGradient315, _linearGradient316, _linearGradient317, _linearGradient318, _linearGradient319, _linearGradient320, _linearGradient321, _linearGradient322, _linearGradient323, _linearGradient324, _linearGradient325, _linearGradient326, _linearGradient327, _linearGradient328, _linearGradient329, _linearGradient330, _linearGradient331, _linearGradient332, _linearGradient333, _linearGradient334, _linearGradient335, _linearGradient336, _linearGradient337, _linearGradient338, _linearGradient339, _linearGradient340, _linearGradient341, _linearGradient342, _linearGradient343, _linearGradient344;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyFt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 411.24 204.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(171.23 0.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.23,165.8a1.27,1.27,0,0,0,1-.36,1.32,1.32,0,0,0,.41-.95V39.77a1.34,1.34,0,0,0-.41-1,1.29,1.29,0,0,0-1-.35,53.8,53.8,0,0,0-6.89.83h0a55.44,55.44,0,0,0-28.52,94.27l.06.08A53.47,53.47,0,0,1,41.5,152.82a43.33,43.33,0,0,1,1.88,6.42c.15.78.25,1.38.3,1.79q0,.3.06.45v.13h0a1.31,1.31,0,0,0,.9,1.14C51.24,164.91,57.78,165.5,64.23,165.8Z",
    style: {
      fill: "none"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -250.76,
    y1: 513.71,
    x2: -250.69,
    y2: 513.64,
    gradientTransform: "matrix(0, -183, -273, 0, 140428.23, -45789.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f07100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e26500"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -248.33,
    y1: 515.42,
    x2: -248.27,
    y2: 515.36,
    gradientTransform: "matrix(0, -681, -296, 0, 152802.23, -169053.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e97e01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e47500"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -250.87,
    y1: 503.84,
    x2: -250.81,
    y2: 503.78,
    gradientTransform: "matrix(0, -300, -376, 0, 189444.23, -75196.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c4300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b75702"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -254.95,
    y1: 512.58,
    x2: -254.89,
    y2: 512.52,
    gradientTransform: "matrix(0, -127, -268, 0, 137534.23, -32297.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f87501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47002"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -248.32,
    y1: 508,
    x2: -248.26,
    y2: 507.94,
    gradientTransform: "matrix(0, -543, -465, 0, 236357.23, -134760.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d76404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d75e02"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -252.88,
    y1: 525.16,
    x2: -252.81,
    y2: 525.1,
    gradientTransform: "matrix(0, -242, -114, 0, 60039.23, -61143.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc127"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -247.6,
    y1: 518.34,
    x2: -247.54,
    y2: 518.27,
    gradientTransform: "matrix(0, -991, -241, 0, 125161.23, -245313.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4970f"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -251.2,
    y1: 525.17,
    x2: -251.14,
    y2: 525.11,
    gradientTransform: "matrix(0, -302, -114, 0, 60039.23, -75808.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f98802"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff960b"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -251.22,
    y1: 512.64,
    x2: -251.15,
    y2: 512.58,
    gradientTransform: "matrix(0, -302, -254, 0, 130368.23, -75808.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8705"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c0f"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -248.23,
    y1: 512.83,
    x2: -248.17,
    y2: 512.77,
    gradientTransform: "matrix(0, -234, -245, 0, 125795.23, -57968.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d95c01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c54a00"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -254.84,
    y1: 504.71,
    x2: -254.78,
    y2: 504.65,
    gradientTransform: "matrix(0, -256, -339, 0, 171120.23, -65222.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9402"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -251.55,
    y1: 518.64,
    x2: -251.48,
    y2: 518.58,
    gradientTransform: "matrix(0, -151, -181, 0, 94060.23, -37883.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f87700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd5e00"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -250.77,
    y1: 553.2,
    x2: -250.7,
    y2: 553.14,
    gradientTransform: "matrix(0, -176, -53, 0, 29503.23, -44033.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca5000"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -247.25,
    y1: 509.75,
    x2: -247.19,
    y2: 509.69,
    gradientTransform: "matrix(0, -384, -415, 0, 211720.23, -94817.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d95d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf5700"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -250.16,
    y1: 511.13,
    x2: -250.1,
    y2: 511.07,
    gradientTransform: "matrix(0, -425, -299, 0, 152980.23, -106275.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff910d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbe25"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -251.59,
    y1: 509.92,
    x2: -251.53,
    y2: 509.86,
    gradientTransform: "matrix(0, -332, -360, 0, 183724.23, -83490.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbb25"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -250.34,
    y1: 508.27,
    x2: -250.28,
    y2: 508.21,
    gradientTransform: "matrix(0, -436, -499, 0, 253780.23, -109109.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbb24"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -249.48,
    y1: 517.91,
    x2: -249.42,
    y2: 517.85,
    gradientTransform: "matrix(0, -197, -191, 0, 99108.23, -49036.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d95e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd6100"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -247.23,
    y1: 517.91,
    x2: -247.17,
    y2: 517.85,
    gradientTransform: "matrix(0, -384, -191, 0, 99108.23, -94817.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac3c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc4800"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -268.36,
    y1: 524.41,
    x2: -268.3,
    y2: 524.35,
    gradientTransform: "matrix(0, -95, -66, 0, 34709.23, -25470.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8d02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9f0d"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -247.4,
    y1: 503.95,
    x2: -247.34,
    y2: 503.89,
    gradientTransform: "matrix(0, -408, -424, 0, 213683.23, -100818.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a73800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a53a00"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -247.18,
    y1: 506.79,
    x2: -247.11,
    y2: 506.72,
    gradientTransform: "matrix(0, -449, -130, 0, 65912.23, -110863.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a94000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b44700"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -256.7,
    y1: 537.23,
    x2: -256.64,
    y2: 537.17,
    gradientTransform: "matrix(0, -101, -75, 0, 40468.23, -25840.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e96900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e06200"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -256.56,
    y1: 507.33,
    x2: -256.5,
    y2: 507.27,
    gradientTransform: "matrix(0, -203, -201, 0, 102024.23, -52059.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8b04"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -256.57,
    y1: 505.63,
    x2: -256.51,
    y2: 505.57,
    gradientTransform: "matrix(0, -203, -316, 0, 159821.23, -52059.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbb14"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -254.84,
    y1: 507.17,
    x2: -254.77,
    y2: 507.11,
    gradientTransform: "matrix(0, -256, -163, 0, 82709.23, -65222.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcd25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa40a"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -248.6,
    y1: 509.85,
    x2: -248.54,
    y2: 509.8,
    gradientTransform: "matrix(0, -160, -268, 0, 136753.23, -39651.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e26e06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db6c03"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -251.46,
    y1: 510.65,
    x2: -251.4,
    y2: 510.58,
    gradientTransform: "matrix(0, -289, -446, 0, 227956.23, -72616.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9f13"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -251.47,
    y1: 515.66,
    x2: -251.41,
    y2: 515.6,
    gradientTransform: "matrix(0, -289, -242, 0, 124990.23, -72616.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc330"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -245.53,
    y1: 509.74,
    x2: -245.47,
    y2: 509.68,
    gradientTransform: "matrix(0, -475, -359, 0, 183144.23, -116463.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d77308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d66a02"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -245.68,
    y1: 516.5,
    x2: -245.62,
    y2: 516.44,
    gradientTransform: "matrix(0, -1011, -275, 0, 142279.23, -248206.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b65400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97500"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -258.93,
    y1: 508.75,
    x2: -258.87,
    y2: 508.68,
    gradientTransform: "matrix(0, -168, -375, 0, 190909.23, -43478.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbb25"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -261.11,
    y1: 507.86,
    x2: -261.05,
    y2: 507.8,
    gradientTransform: "matrix(0, -141, -445, 0, 226119.23, -36793.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbb24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa412"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -270.21,
    y1: 508.2,
    x2: -270.14,
    y2: 508.13,
    gradientTransform: "matrix(0, -88, -334, 0, 169841.23, -23755.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa10f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9308"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -261.11,
    y1: 507.54,
    x2: -261.05,
    y2: 507.48,
    gradientTransform: "matrix(0, -141, -398, 0, 202103.23, -36793.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa20e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff970a"
  }))), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -260.87,
    y1: 505.59,
    x2: -260.81,
    y2: 505.53,
    gradientTransform: "matrix(0, -157, -407, 0, 205822.23, -40946.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa408"
  }))), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -259.12,
    y1: 508.79,
    x2: -259.06,
    y2: 508.72,
    gradientTransform: "matrix(0, -178, -117, 0, 59571.23, -46112.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c06"
  }))), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -264.92,
    y1: 506.78,
    x2: -264.86,
    y2: 506.71,
    gradientTransform: "matrix(0, -115, -309, 0, 156657.23, -30446.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9607"
  }))), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -258.95,
    y1: 505.8,
    x2: -258.89,
    y2: 505.74,
    gradientTransform: "matrix(0, -168, -372, 0, 188208.23, -43484.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c08"
  }))), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -260.16,
    y1: 511.37,
    x2: -260.1,
    y2: 511.31,
    gradientTransform: "matrix(0, -160, -138, 0, 70644.23, -41610.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff990b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffaf11"
  }))), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -262.45,
    y1: 505.75,
    x2: -262.39,
    y2: 505.69,
    gradientTransform: "matrix(0, -139, -381, 0, 192744.23, -36465.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9a05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9a07"
  }))), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -251.55,
    y1: 520.04,
    x2: -251.49,
    y2: 519.98,
    gradientTransform: "matrix(0, -335, -84, 0, 43781.23, -84229.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff900a"
  }))), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -249.11,
    y1: 505.14,
    x2: -249.05,
    y2: 505.08,
    gradientTransform: "matrix(0, -384, -232, 0, 117218.23, -95575.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e26d01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c05700"
  }))), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -260.11,
    y1: 519.84,
    x2: -260.05,
    y2: 519.78,
    gradientTransform: "matrix(0, -110, -22, 0, 11465.23, -28555.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d77305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d96c03"
  }))), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -248,
    y1: 517.55,
    x2: -247.94,
    y2: 517.49,
    gradientTransform: "matrix(0, -77, -69, 0, 35780.23, -18954.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#993600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a2700"
  }))), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -246.71,
    y1: 514.5,
    x2: -246.65,
    y2: 514.44,
    gradientTransform: "matrix(0, -219, -89, 0, 45860.23, -53886.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#973400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812000"
  }))), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -248.52,
    y1: 511.56,
    x2: -248.46,
    y2: 511.5,
    gradientTransform: "matrix(0, -74, -129, 0, 66063.23, -18251.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#962e00"
  }))), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -247.59,
    y1: 513.7,
    x2: -247.53,
    y2: 513.64,
    gradientTransform: "matrix(0, -142, -103, 0, 52985.23, -35021.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#811f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822100"
  }))), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -246.03,
    y1: 505.48,
    x2: -245.97,
    y2: 505.42,
    gradientTransform: "matrix(0, -159, -479, 0, 242179.23, -38967.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b95401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad4b01"
  }))), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -246.23,
    y1: 513.97,
    x2: -246.17,
    y2: 513.91,
    gradientTransform: "matrix(0, -218, -110, 0, 56616.23, -53531.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b2900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#902a00"
  }))), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -246.36,
    y1: 507.93,
    x2: -246.3,
    y2: 507.87,
    gradientTransform: "matrix(0, -144, -238, 0, 120956.23, -35327.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e3c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#902d00"
  }))), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -246.24,
    y1: 509,
    x2: -246.18,
    y2: 508.94,
    gradientTransform: "matrix(0, -218, -195, 0, 99327.23, -53531.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#963000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#942e00"
  }))), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -253.56,
    y1: 512.96,
    x2: -253.5,
    y2: 512.9,
    gradientTransform: "matrix(0, -220, -281, 0, 144321.23, -55731.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb21a"
  }))), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -252.86,
    y1: 512.86,
    x2: -252.8,
    y2: 512.8,
    gradientTransform: "matrix(0, -242, -279, 0, 143260.23, -61143.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f68501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa411"
  }))), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -262.21,
    y1: 531.59,
    x2: -262.15,
    y2: 531.52,
    gradientTransform: "matrix(0, -109, -99, 0, 52819.23, -28536.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbb23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2"
  }))), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -262.2,
    y1: 514.98,
    x2: -262.14,
    y2: 514.92,
    gradientTransform: "matrix(0, -109, -249, 0, 128419.23, -28536.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbe24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc029"
  }))), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -253.51,
    y1: 513.06,
    x2: -253.45,
    y2: 513,
    gradientTransform: "matrix(0, -247, -301, 0, 154627.23, -62573.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa91a"
  }))), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -250.09,
    y1: 512.84,
    x2: -250.03,
    y2: 512.78,
    gradientTransform: "matrix(0, -458, -279, 0, 143260.23, -114499.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb923"
  }))), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -250.08,
    y1: 509.9,
    x2: -250.02,
    y2: 509.84,
    gradientTransform: "matrix(0, -458, -441, 0, 225047.23, -114499.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa91c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb422"
  }))), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -252.62,
    y1: 505.15,
    x2: -252.55,
    y2: 505.08,
    gradientTransform: "matrix(0, -180, -232, 0, 117218.23, -45391.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb6e01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b14700"
  }))), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -245.33,
    y1: 509.87,
    x2: -245.27,
    y2: 509.81,
    gradientTransform: "matrix(0, -91, -205, 0, 104613.23, -22170.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#963100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#993700"
  }))), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -245.59,
    y1: 505.33,
    x2: -245.53,
    y2: 505.27,
    gradientTransform: "matrix(0, -97, -530, 0, 267883.23, -23668.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c05500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad4800"
  }))), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -245.78,
    y1: 509.66,
    x2: -245.72,
    y2: 509.6,
    gradientTransform: "matrix(0, -186, -212, 0, 108134.23, -45562.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#933400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#912e00"
  }))), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -245.79,
    y1: 526.69,
    x2: -245.73,
    y2: 526.63,
    gradientTransform: "matrix(0, -186, -51, 0, 26946.23, -45562.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#993100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#912f00"
  }))), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -248.08,
    y1: 506.18,
    x2: -248.02,
    y2: 506.12,
    gradientTransform: "matrix(0, -423, -498, 0, 252155.23, -104843.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed810d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb7808"
  }))), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -250.91,
    y1: 516.72,
    x2: -250.84,
    y2: 516.65,
    gradientTransform: "matrix(0, -117, -223, 0, 115427.23, -29239.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b94100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c04700"
  }))), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -247.34,
    y1: 531.97,
    x2: -247.28,
    y2: 531.91,
    gradientTransform: "matrix(0, -252, -107, 0, 57131.23, -62197.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cd5000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c84e00"
  }))), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -247.34,
    y1: 513.82,
    x2: -247.28,
    y2: 513.76,
    gradientTransform: "matrix(0, -252, -283, 0, 145607.23, -62197.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c04700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b40"
  }))), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -248.15,
    y1: 513.82,
    x2: -248.09,
    y2: 513.76,
    gradientTransform: "matrix(0, -221, -283, 0, 145607.23, -54719.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be4700"
  }))), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -247.97,
    y1: 511.56,
    x2: -247.91,
    y2: 511.5,
    gradientTransform: "matrix(0, -306, -399, 0, 204327.23, -75761.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d45a00"
  }))), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -246.4,
    y1: 518.96,
    x2: -246.34,
    y2: 518.9,
    gradientTransform: "matrix(0, -460, -227, 0, 118038.23, -113211.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f98100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7b00"
  }))), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -246.45,
    y1: 517.09,
    x2: -246.39,
    y2: 517.03,
    gradientTransform: "matrix(0, -434, -245, 0, 126914.23, -106815.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e46900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d65c00"
  }))), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -246.61,
    y1: 513.67,
    x2: -246.55,
    y2: 513.61,
    gradientTransform: "matrix(0, -386, -320, 0, 164590.23, -95055.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d65d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d45a00"
  }))), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -247.5,
    y1: 512.19,
    x2: -247.44,
    y2: 512.13,
    gradientTransform: "matrix(0, -244, -372, 0, 190746.23, -60265.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c54b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb5000"
  }))), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -251.73,
    y1: 511.57,
    x2: -251.67,
    y2: 511.51,
    gradientTransform: "matrix(0, -100, -399, 0, 204327.23, -25057.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b23d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be4700"
  }))), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -247.2,
    y1: 507.71,
    x2: -247.14,
    y2: 507.65,
    gradientTransform: "matrix(0, -301, -219, 0, 111250.23, -74277.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#882600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f3500"
  }))), _linearGradient77 || (_linearGradient77 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -247.19,
    y1: 512.66,
    x2: -247.13,
    y2: 512.6,
    gradientTransform: "matrix(0, -301, -111, 0, 56975.23, -74277.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e1d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a2e00"
  }))), _linearGradient78 || (_linearGradient78 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -247.66,
    y1: 507.5,
    x2: -247.6,
    y2: 507.44,
    gradientTransform: "matrix(0, -340, -274, 0, 139127.23, -84085.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b94700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa3f00"
  }))), _linearGradient79 || (_linearGradient79 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -248.18,
    y1: 506.17,
    x2: -248.12,
    y2: 506.11,
    gradientTransform: "matrix(0, -491, -498, 0, 252155.23, -121767.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8840a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7f07"
  }))), _linearGradient80 || (_linearGradient80 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -250.01,
    y1: 506.95,
    x2: -249.95,
    y2: 506.89,
    gradientTransform: "matrix(0, -319, -481, 0, 243940.23, -79682.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f27c06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff880a"
  }))), _linearGradient81 || (_linearGradient81 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -248.15,
    y1: 507.08,
    x2: -248.09,
    y2: 507.02,
    gradientTransform: "matrix(0, -495, -353, 0, 179075.23, -122751.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e06a03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7c04"
  }))), _linearGradient82 || (_linearGradient82 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -266.99,
    y1: 507.55,
    x2: -266.93,
    y2: 507.49,
    gradientTransform: "matrix(0, -73, -314, 0, 159458.23, -19430.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef6d03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f67301"
  }))), _linearGradient83 || (_linearGradient83 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -257.71,
    y1: 508.02,
    x2: -257.65,
    y2: 507.96,
    gradientTransform: "matrix(0, -131, -279, 0, 141818.23, -33702.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f27001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7f01"
  }))), _linearGradient84 || (_linearGradient84 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -257.72,
    y1: 506.75,
    x2: -257.66,
    y2: 506.69,
    gradientTransform: "matrix(0, -131, -309, 0, 156650.23, -33702.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed6c01"
  }))), _linearGradient85 || (_linearGradient85 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -257.05,
    y1: 508.41,
    x2: -256.98,
    y2: 508.35,
    gradientTransform: "matrix(0, -145, -258, 0, 131255.23, -37215.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f87700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7c00"
  }))), _linearGradient86 || (_linearGradient86 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: -251.84,
    y1: 519.84,
    x2: -251.78,
    y2: 519.79,
    gradientTransform: "matrix(0, -274, -85, 0, 44284.23, -68949.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f67301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed6c00"
  }))), _linearGradient87 || (_linearGradient87 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: -249.38,
    y1: 509.12,
    x2: -249.32,
    y2: 509.06,
    gradientTransform: "matrix(0, -493, -222, 0, 113111.23, -122885.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f87500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f87500"
  }))), _linearGradient88 || (_linearGradient88 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: -250.23,
    y1: 519.85,
    x2: -250.17,
    y2: 519.79,
    gradientTransform: "matrix(0, -410, -85, 0, 44284.23, -102550.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb6c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7b00"
  }))), _linearGradient89 || (_linearGradient89 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: -248.22,
    y1: 507.56,
    x2: -248.16,
    y2: 507.5,
    gradientTransform: "matrix(0, -180, -389, 0, 197545.23, -44551.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8870f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d77107"
  }))), _linearGradient90 || (_linearGradient90 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: -245.32,
    y1: 509.97,
    x2: -245.26,
    y2: 509.91,
    gradientTransform: "matrix(0, -491, -402, 0, 205175.23, -120283.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d67b0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca6608"
  }))), _linearGradient91 || (_linearGradient91 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: -245.32,
    y1: 506.98,
    x2: -245.26,
    y2: 506.92,
    gradientTransform: "matrix(0, -491, -808, 0, 409809.23, -120283.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c86a08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#af4700"
  }))), _linearGradient92 || (_linearGradient92 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: -245.81,
    y1: 510.66,
    x2: -245.75,
    y2: 510.6,
    gradientTransform: "matrix(0, -296, -416, 0, 212633.23, -72604.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac4300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be4d00"
  }))), _linearGradient93 || (_linearGradient93 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: -246.61,
    y1: 514.78,
    x2: -246.55,
    y2: 514.72,
    gradientTransform: "matrix(0, -217, -257, 0, 132497.23, -53370.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e46200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c54e00"
  }))), _linearGradient94 || (_linearGradient94 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: -249.11,
    y1: 503.94,
    x2: -249.05,
    y2: 503.87,
    gradientTransform: "matrix(0, -168, -436, 0, 219719.23, -41731.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b14800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c15100"
  }))), _linearGradient95 || (_linearGradient95 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: -246.5,
    y1: 513.36,
    x2: -246.44,
    y2: 513.3,
    gradientTransform: "matrix(0, -256, -291, 0, 149576.23, -62964.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c14d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c84e00"
  }))), _linearGradient96 || (_linearGradient96 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: -248.27,
    y1: 513.34,
    x2: -248.22,
    y2: 513.29,
    gradientTransform: "matrix(0, -148, -291, 0, 149576.23, -36613.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c34800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc4500"
  }))), _linearGradient97 || (_linearGradient97 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -247.44,
    y1: 509.76,
    x2: -247.38,
    y2: 509.7,
    gradientTransform: "matrix(0, -259, -415, 0, 211720.23, -63958.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c54e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb5100"
  }))), _linearGradient98 || (_linearGradient98 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -246.13,
    y1: 509.65,
    x2: -246.07,
    y2: 509.59,
    gradientTransform: "matrix(0, -199, -212, 0, 108134.23, -48829.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#913400"
  }))), _linearGradient99 || (_linearGradient99 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: -247.04,
    y1: 508.44,
    x2: -246.98,
    y2: 508.38,
    gradientTransform: "matrix(0, -129, -247, 0, 125664.23, -31726.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#822600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#902e00"
  }))), _linearGradient100 || (_linearGradient100 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: -247.09,
    y1: 507.49,
    x2: -247.03,
    y2: 507.43,
    gradientTransform: "matrix(0, -197, -313, 0, 158928.23, -48536.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#963300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b24e00"
  }))), _linearGradient101 || (_linearGradient101 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -245.22,
    y1: 510.45,
    x2: -245.16,
    y2: 510.39,
    gradientTransform: "matrix(0, -154, -206, 0, 105251.23, -37605.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#963600"
  }))), _linearGradient102 || (_linearGradient102 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: -244.35,
    y1: 506.45,
    x2: -244.28,
    y2: 506.39,
    gradientTransform: "matrix(0, -171, -588, 0, 297897.23, -41616.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a24300"
  }))), _linearGradient103 || (_linearGradient103 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: -244.79,
    y1: 510.46,
    x2: -244.73,
    y2: 510.41,
    gradientTransform: "matrix(0, -234, -206, 0, 105251.23, -57114.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a3100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e2e00"
  }))), _linearGradient104 || (_linearGradient104 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: -250.33,
    y1: 506.93,
    x2: -250.27,
    y2: 506.87,
    gradientTransform: "matrix(0, -354, -481, 0, 243940.23, -88556.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff880a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8506"
  }))), _linearGradient105 || (_linearGradient105 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -250.32,
    y1: 509.55,
    x2: -250.26,
    y2: 509.49,
    gradientTransform: "matrix(0, -354, -249, 0, 126977.23, -88556.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7a05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f87501"
  }))), _linearGradient106 || (_linearGradient106 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: -251.69,
    y1: 509.56,
    x2: -251.62,
    y2: 509.5,
    gradientTransform: "matrix(0, -281, -249, 0, 126977.23, -70671.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e76800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e66600"
  }))), _linearGradient107 || (_linearGradient107 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: -251.55,
    y1: 510.24,
    x2: -251.49,
    y2: 510.17,
    gradientTransform: "matrix(0, -335, -225, 0, 114905.23, -84229.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f27300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8d04"
  }))), _linearGradient108 || (_linearGradient108 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: -251.68,
    y1: 508.2,
    x2: -251.62,
    y2: 508.15,
    gradientTransform: "matrix(0, -328, -334, 0, 169841.23, -82514.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8d04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9608"
  }))), _linearGradient109 || (_linearGradient109 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: -248.08,
    y1: 512.82,
    x2: -248.02,
    y2: 512.76,
    gradientTransform: "matrix(0, -298, -245, 0, 125795.23, -73811.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca5100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c04b00"
  }))), _linearGradient110 || (_linearGradient110 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: -248.06,
    y1: 511.33,
    x2: -248,
    y2: 511.26,
    gradientTransform: "matrix(0, -298, -322, 0, 164810.23, -73811.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de6402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d96101"
  }))), _linearGradient111 || (_linearGradient111 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: -247.44,
    y1: 514.44,
    x2: -247.38,
    y2: 514.38,
    gradientTransform: "matrix(0, -520, -207, 0, 106643.23, -128558.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b74400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca5100"
  }))), _linearGradient112 || (_linearGradient112 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: -250.77,
    y1: 511.31,
    x2: -250.71,
    y2: 511.25,
    gradientTransform: "matrix(0, -176, -322, 0, 164810.23, -44033.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d15800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c54e00"
  }))), _linearGradient113 || (_linearGradient113 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: -250.66,
    y1: 512.75,
    x2: -250.6,
    y2: 512.69,
    gradientTransform: "matrix(0, -193, -269, 0, 138098.23, -48279.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cd5500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d75d00"
  }))), _linearGradient114 || (_linearGradient114 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: -249.54,
    y1: 514.66,
    x2: -249.48,
    y2: 514.6,
    gradientTransform: "matrix(0, -254, -221, 0, 113906.23, -63285.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e46600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e06500"
  }))), _linearGradient115 || (_linearGradient115 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: -245.75,
    y1: 502.45,
    x2: -245.69,
    y2: 502.39,
    gradientTransform: "matrix(0, -1353, -48, 0, 24117.23, -332335.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c15700"
  }))), _linearGradient116 || (_linearGradient116 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: -248.36,
    y1: 503.85,
    x2: -248.3,
    y2: 503.79,
    gradientTransform: "matrix(0, -287, -467, 0, 235293.23, -71173.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c05401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c85a00"
  }))), _linearGradient117 || (_linearGradient117 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -246.75,
    y1: 502.51,
    x2: -246.67,
    y2: 502.43,
    gradientTransform: "matrix(0, -562, -50, 0, 25125.23, -138540.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b74b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd5c00"
  }))), _linearGradient118 || (_linearGradient118 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: -247.17,
    y1: 502.79,
    x2: -247.11,
    y2: 502.73,
    gradientTransform: "matrix(0, -447, -62, 0, 31173.23, -110365.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d25c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca5400"
  }))), _linearGradient119 || (_linearGradient119 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: -331.17,
    y1: 503.12,
    x2: -331.11,
    y2: 503.06,
    gradientTransform: "matrix(0, -17, -86, 0, 43268.23, -5566.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#933c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#943c00"
  }))), _linearGradient120 || (_linearGradient120 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: -249.04,
    y1: 519.21,
    x2: -248.98,
    y2: 519.15,
    gradientTransform: "matrix(0, -205, -229, 0, 119142.23, -50941.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd9605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f48b02"
  }))), _linearGradient121 || (_linearGradient121 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: -245.71,
    y1: 540.79,
    x2: -245.64,
    y2: 540.73,
    gradientTransform: "matrix(0, -1101, -98, 0, 53249.23, -270346.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e68200"
  }))), _linearGradient122 || (_linearGradient122 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: -253.22,
    y1: 514.07,
    x2: -253.15,
    y2: 514,
    gradientTransform: "matrix(0, -201, -336, 0, 172962.23, -50831.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f99307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd9006"
  }))), _linearGradient123 || (_linearGradient123 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: -247.29,
    y1: 595.45,
    x2: -247.23,
    y2: 595.4,
    gradientTransform: "matrix(0, -1133, -40, 0, 24074.23, -280103.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb990f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa91a"
  }))), _linearGradient124 || (_linearGradient124 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: -246.92,
    y1: 507.02,
    x2: -246.86,
    y2: 506.96,
    gradientTransform: "matrix(0, -278, -337, 0, 170941.23, -68509.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#842600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#963100"
  }))), _linearGradient125 || (_linearGradient125 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: -246.93,
    y1: 507.49,
    x2: -246.87,
    y2: 507.43,
    gradientTransform: "matrix(0, -278, -313, 0, 158928.23, -68509.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e3a01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c35900"
  }))), _linearGradient126 || (_linearGradient126 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: -247.68,
    y1: 507.03,
    x2: -247.62,
    y2: 506.97,
    gradientTransform: "matrix(0, -214, -337, 0, 170941.23, -52875.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#932d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c55000"
  }))), _linearGradient127 || (_linearGradient127 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: -248.2,
    y1: 509.32,
    x2: -248.14,
    y2: 509.26,
    gradientTransform: "matrix(0, -180, -251, 0, 127934.23, -44551.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c35701"
  }))), _linearGradient128 || (_linearGradient128 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: -247.35,
    y1: 507.68,
    x2: -247.3,
    y2: 507.62,
    gradientTransform: "matrix(0, -386, -288, 0, 146294.23, -95355.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c54e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd5a00"
  }))), _linearGradient129 || (_linearGradient129 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: -250.33,
    y1: 512.57,
    x2: -250.27,
    y2: 512.51,
    gradientTransform: "matrix(0, -272, -268, 0, 137534.23, -68007.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f07100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd7c01"
  }))), _linearGradient130 || (_linearGradient130 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: -248.31,
    y1: 512.86,
    x2: -248.25,
    y2: 512.8,
    gradientTransform: "matrix(0, -543, -248, 0, 127344.23, -134760.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8804"
  }))), _linearGradient131 || (_linearGradient131 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: -250.01,
    y1: 512.65,
    x2: -249.94,
    y2: 512.58,
    gradientTransform: "matrix(0, -358, -254, 0, 130368.23, -89435.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8a04"
  }))), _linearGradient132 || (_linearGradient132 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: -255.95,
    y1: 508.28,
    x2: -255.89,
    y2: 508.22,
    gradientTransform: "matrix(0, -218, -499, 0, 253780.23, -55778.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb970e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa517"
  }))), _linearGradient133 || (_linearGradient133 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: -255.95,
    y1: 518.88,
    x2: -255.89,
    y2: 518.82,
    gradientTransform: "matrix(0, -218, -141, 0, 73309.23, -55778.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbc29"
  }))), _linearGradient134 || (_linearGradient134 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: -243.15,
    y1: 515.53,
    x2: -243.08,
    y2: 515.47,
    gradientTransform: "matrix(0, -116, -193, 0, 99656.23, -28033.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d27a10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c86608"
  }))), _linearGradient135 || (_linearGradient135 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: -243.36,
    y1: 509.75,
    x2: -243.3,
    y2: 509.69,
    gradientTransform: "matrix(0, -106, -359, 0, 183144.23, -25629.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de780a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca6001"
  }))), _linearGradient136 || (_linearGradient136 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: -243.37,
    y1: 511.93,
    x2: -243.31,
    y2: 511.87,
    gradientTransform: "matrix(0, -106, -251, 0, 128637.23, -25629.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d46801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c65c01"
  }))), _linearGradient137 || (_linearGradient137 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: -248.67,
    y1: 522.18,
    x2: -248.61,
    y2: 522.12,
    gradientTransform: "matrix(0, -249, -163, 0, 85321.23, -61811.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b13f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c34d00"
  }))), _linearGradient138 || (_linearGradient138 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: -250.76,
    y1: 522.54,
    x2: -250.7,
    y2: 522.48,
    gradientTransform: "matrix(0, -183, -152, 0, 79625.23, -45789.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de6200"
  }))), _linearGradient139 || (_linearGradient139 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: -251.45,
    y1: 517.03,
    x2: -251.39,
    y2: 516.96,
    gradientTransform: "matrix(0, -163, -223, 0, 115501.23, -40889.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c04900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb5300"
  }))), _linearGradient140 || (_linearGradient140 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: -243.46,
    y1: 530.55,
    x2: -243.4,
    y2: 530.49,
    gradientTransform: "matrix(0, -79, -75, 0, 39933.23, -19070.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e07504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb7c06"
  }))), _linearGradient141 || (_linearGradient141 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: -243.63,
    y1: 506.87,
    x2: -243.57,
    y2: 506.81,
    gradientTransform: "matrix(0, -85, -530, 0, 268753.23, -20546.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de7b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd6608"
  }))), _linearGradient142 || (_linearGradient142 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: -245.59,
    y1: 542.1,
    x2: -245.53,
    y2: 542.04,
    gradientTransform: "matrix(0, -429, -53, 0, 28875.23, -105193.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e27504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed7a06"
  }))), _linearGradient143 || (_linearGradient143 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: -245.56,
    y1: 506.86,
    x2: -245.5,
    y2: 506.8,
    gradientTransform: "matrix(0, -276, -530, 0, 268753.23, -67611.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b75405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed7f09"
  }))), _linearGradient144 || (_linearGradient144 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: -245.66,
    y1: 520.6,
    x2: -245.6,
    y2: 520.54,
    gradientTransform: "matrix(0, -373, -118, 0, 61570.23, -91473.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db6e04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e47405"
  }))), _linearGradient145 || (_linearGradient145 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: -244.92,
    y1: 517.45,
    x2: -244.86,
    y2: 517.39,
    gradientTransform: "matrix(0, -53, -235, 0, 121825.23, -12826.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a23c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a53c00"
  }))), _linearGradient146 || (_linearGradient146 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: -245.41,
    y1: 514.13,
    x2: -245.35,
    y2: 514.07,
    gradientTransform: "matrix(0, -551, -334, 0, 171956.23, -135046.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa4f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c55500"
  }))), _linearGradient147 || (_linearGradient147 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: -245.81,
    y1: 552.9,
    x2: -245.75,
    y2: 552.84,
    gradientTransform: "matrix(0, -251, -69, 0, 38386.23, -61546.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c55100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb5900"
  }))), _linearGradient148 || (_linearGradient148 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: -248.07,
    y1: 507.41,
    x2: -248.01,
    y2: 507.35,
    gradientTransform: "matrix(0, -427, -356, 0, 180729.23, -105823.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de7508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed7b0c"
  }))), _linearGradient149 || (_linearGradient149 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: -248.06,
    y1: 510.36,
    x2: -248,
    y2: 510.3,
    gradientTransform: "matrix(0, -427, -230, 0, 117488.23, -105823.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c15302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d76404"
  }))), _linearGradient150 || (_linearGradient150 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: -247.34,
    y1: 508.63,
    x2: -247.28,
    y2: 508.57,
    gradientTransform: "matrix(0, -386, -263, 0, 133857.23, -95355.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c85500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d76a04"
  }))), _linearGradient151 || (_linearGradient151 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: -247.37,
    y1: 509.31,
    x2: -247.31,
    y2: 509.25,
    gradientTransform: "matrix(0, -382, -251, 0, 127934.23, -94371.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de7306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9820f"
  }))), _linearGradient152 || (_linearGradient152 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: -245.76,
    y1: 507.46,
    x2: -245.7,
    y2: 507.4,
    gradientTransform: "matrix(0, -498, -404, 0, 205114.23, -122229.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#903100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a94400"
  }))), _linearGradient153 || (_linearGradient153 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: -245.76,
    y1: 507.27,
    x2: -245.7,
    y2: 507.21,
    gradientTransform: "matrix(0, -498, -465, 0, 235993.23, -122229.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af4d01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d76c02"
  }))), _linearGradient154 || (_linearGradient154 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: -246.06,
    y1: 506.78,
    x2: -246,
    y2: 506.72,
    gradientTransform: "matrix(0, -344, -479, 0, 242839.23, -84499.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#993c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b44e00"
  }))), _linearGradient155 || (_linearGradient155 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: -246.58,
    y1: 509.66,
    x2: -246.52,
    y2: 509.6,
    gradientTransform: "matrix(0, -228, -314, 0, 160158.23, -56079.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd7104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d76902"
  }))), _linearGradient156 || (_linearGradient156 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: -247.07,
    y1: 506.78,
    x2: -247.01,
    y2: 506.72,
    gradientTransform: "matrix(0, -197, -479, 0, 242839.23, -48536.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a94300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b94f00"
  }))), _linearGradient157 || (_linearGradient157 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: -246.68,
    y1: 509.65,
    x2: -246.62,
    y2: 509.59,
    gradientTransform: "matrix(0, -334, -314, 0, 160158.23, -82252.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e67508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97708"
  }))), _linearGradient158 || (_linearGradient158 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: -250.85,
    y1: 507.36,
    x2: -250.79,
    y2: 507.3,
    gradientTransform: "matrix(0, -72, -413, 0, 209641.23, -17931.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c86202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de7004"
  }))), _linearGradient159 || (_linearGradient159 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: -247.72,
    y1: 528.69,
    x2: -247.66,
    y2: 528.63,
    gradientTransform: "matrix(0, -203, -71, 0, 37662.23, -50157.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed7c08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e67507"
  }))), _linearGradient160 || (_linearGradient160 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: -247.95,
    y1: 503.61,
    x2: -247.89,
    y2: 503.55,
    gradientTransform: "matrix(0, -744, -197, 0, 99212.23, -184408.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#913700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b75503"
  }))), _linearGradient161 || (_linearGradient161 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: -248,
    y1: 503.83,
    x2: -247.94,
    y2: 503.78,
    gradientTransform: "matrix(0, -732, -376, 0, 189444.23, -181468.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af4d03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb8e0d"
  }))), _linearGradient162 || (_linearGradient162 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: -249.16,
    y1: 504.25,
    x2: -249.1,
    y2: 504.19,
    gradientTransform: "matrix(0, -550, -436, 0, 219865.23, -136996.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e46e04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa114"
  }))), _linearGradient163 || (_linearGradient163 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: -252.94,
    y1: 504.25,
    x2: -252.88,
    y2: 504.19,
    gradientTransform: "matrix(0, -310, -436, 0, 219865.23, -78388.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc81c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffad0b"
  }))), _linearGradient164 || (_linearGradient164 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: -248.47,
    y1: 509.84,
    x2: -248.41,
    y2: 509.78,
    gradientTransform: "matrix(0, -220, -268, 0, 136753.23, -54542.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb820d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f07c06"
  }))), _linearGradient165 || (_linearGradient165 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: -250.32,
    y1: 508.36,
    x2: -250.26,
    y2: 508.3,
    gradientTransform: "matrix(0, -142, -408, 0, 207539.23, -35432.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd6001"
  }))), _linearGradient166 || (_linearGradient166 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: -246.54,
    y1: 516.18,
    x2: -246.48,
    y2: 516.12,
    gradientTransform: "matrix(0, -412, -170, 0, 87896.23, -101440.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c04b02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b94000"
  }))), _linearGradient167 || (_linearGradient167 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: -246.55,
    y1: 510.57,
    x2: -246.49,
    y2: 510.5,
    gradientTransform: "matrix(0, -412, -277, 0, 141557.23, -101440.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db6603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e06604"
  }))), _linearGradient168 || (_linearGradient168 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: -248.25,
    y1: 516.98,
    x2: -248.19,
    y2: 516.92,
    gradientTransform: "matrix(0, -234, -160, 0, 82866.23, -57968.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be4300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c04500"
  }))), _linearGradient169 || (_linearGradient169 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: -248.45,
    y1: 509.58,
    x2: -248.39,
    y2: 509.52,
    gradientTransform: "matrix(0, -220, -319, 0, 162683.23, -54542.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f07707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e76901"
  }))), _linearGradient170 || (_linearGradient170 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: -248.32,
    y1: 507.77,
    x2: -248.26,
    y2: 507.71,
    gradientTransform: "matrix(0, -321, -459, 0, 233192.23, -79604.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c54d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f27805"
  }))), _linearGradient171 || (_linearGradient171 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: -250.97,
    y1: 504.01,
    x2: -250.91,
    y2: 503.95,
    gradientTransform: "matrix(0, -295, -336, 0, 169354.23, -73971.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#943800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf6403"
  }))), _linearGradient172 || (_linearGradient172 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: -267.07,
    y1: 510.03,
    x2: -267.01,
    y2: 509.97,
    gradientTransform: "matrix(0, -77, -53, 0, 27058.23, -20511.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d77003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d76a02"
  }))), _linearGradient173 || (_linearGradient173 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: -264.22,
    y1: 507.51,
    x2: -264.13,
    y2: 507.43,
    gradientTransform: "matrix(0, -91, -83, 0, 42148.23, -23991.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d96801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e67705"
  }))), _linearGradient174 || (_linearGradient174 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: -247.3,
    y1: 512.72,
    x2: -247.24,
    y2: 512.66,
    gradientTransform: "matrix(0, -683, -357, 0, 183260.23, -168809.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d65c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47b02"
  }))), _linearGradient175 || (_linearGradient175 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: -247.31,
    y1: 514.56,
    x2: -247.25,
    y2: 514.49,
    gradientTransform: "matrix(0, -683, -275, 0, 141709.23, -168809.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e26600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8402"
  }))), _linearGradient176 || (_linearGradient176 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: -247.83,
    y1: 514.57,
    x2: -247.77,
    y2: 514.51,
    gradientTransform: "matrix(0, -568, -275, 0, 141709.23, -140682.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f67b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9907"
  }))), _linearGradient177 || (_linearGradient177 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: -259.69,
    y1: 512.62,
    x2: -259.63,
    y2: 512.56,
    gradientTransform: "matrix(0, -112, -354, 0, 181680.23, -29026.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa20a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9104"
  }))), _linearGradient178 || (_linearGradient178 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: -245.28,
    y1: 503.92,
    x2: -245.22,
    y2: 503.85,
    gradientTransform: "matrix(0, -462, -838, 0, 422277.23, -113149.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d27700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c65500"
  }))), _linearGradient179 || (_linearGradient179 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: -245.58,
    y1: 503.68,
    x2: -245.52,
    y2: 503.61,
    gradientTransform: "matrix(0, -791, -229, 0, 115341.23, -194083.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b65900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b94d00"
  }))), _linearGradient180 || (_linearGradient180 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: -246.02,
    y1: 504.22,
    x2: -245.96,
    y2: 504.16,
    gradientTransform: "matrix(0, -310, -609, 0, 307090.23, -76113.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a13700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a93b00"
  }))), _linearGradient181 || (_linearGradient181 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: -255.78,
    y1: 515.54,
    x2: -255.72,
    y2: 515.48,
    gradientTransform: "matrix(0, -217, -113, 0, 58350.23, -55482.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8a0a"
  }))), _linearGradient182 || (_linearGradient182 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: -255.79,
    y1: 509.33,
    x2: -255.73,
    y2: 509.27,
    gradientTransform: "matrix(0, -217, -215, 0, 109590.23, -55482.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa10d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9a0d"
  }))), _linearGradient183 || (_linearGradient183 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: -260.15,
    y1: 507.46,
    x2: -260.09,
    y2: 507.4,
    gradientTransform: "matrix(0, -160, -297, 0, 150789.23, -41610.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8e06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa50d"
  }))), _linearGradient184 || (_linearGradient184 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: -253.11,
    y1: 505.45,
    x2: -253.05,
    y2: 505.39,
    gradientTransform: "matrix(0, -150, -336, 0, 169866.23, -37881.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9111"
  }))), _linearGradient185 || (_linearGradient185 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: -247.58,
    y1: 506.74,
    x2: -247.51,
    y2: 506.68,
    gradientTransform: "matrix(0, -391, -261, 0, 132314.23, -96689.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c55700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c35503"
  }))), _linearGradient186 || (_linearGradient186 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: -250.16,
    y1: 506.62,
    x2: -250.1,
    y2: 506.56,
    gradientTransform: "matrix(0, -237, -224, 0, 113530.23, -59196.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8870a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb9012"
  }))), _linearGradient187 || (_linearGradient187 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: -247.1,
    y1: 505.36,
    x2: -247.04,
    y2: 505.3,
    gradientTransform: "matrix(0, -485, -352, 0, 177930.23, -119719.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d76901"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db6e05"
  }))), _linearGradient188 || (_linearGradient188 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: -247.08,
    y1: 504.97,
    x2: -247.02,
    y2: 504.91,
    gradientTransform: "matrix(0, -485, -378, 0, 190904.23, -119719.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c14f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c65803"
  }))), _linearGradient189 || (_linearGradient189 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: -247.29,
    y1: 507.77,
    x2: -247.23,
    y2: 507.71,
    gradientTransform: "matrix(0, -581, -459, 0, 233192.23, -143564.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c2d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb4803"
  }))), _linearGradient190 || (_linearGradient190 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: -247.28,
    y1: 508.42,
    x2: -247.22,
    y2: 508.36,
    gradientTransform: "matrix(0, -581, -425, 0, 216213.23, -143564.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c54d00"
  }))), _linearGradient191 || (_linearGradient191 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: -250.02,
    y1: 511.81,
    x2: -249.96,
    y2: 511.75,
    gradientTransform: "matrix(0, -260, -215, 0, 110158.23, -64919.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db6a06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c15102"
  }))), _linearGradient192 || (_linearGradient192 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: -254.62,
    y1: 508.41,
    x2: -254.56,
    y2: 508.35,
    gradientTransform: "matrix(0, -135, -352, 0, 179069.23, -34294.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d16504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb5801"
  }))), _linearGradient193 || (_linearGradient193 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: -266.25,
    y1: 508.19,
    x2: -266.18,
    y2: 508.12,
    gradientTransform: "matrix(0, -61, -449, 0, 228309.23, -16164.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cd5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd5301"
  }))), _linearGradient194 || (_linearGradient194 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: -249.65,
    y1: 508.01,
    x2: -249.58,
    y2: 507.94,
    gradientTransform: "matrix(0, -345, -465, 0, 236357.23, -86052.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d25401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf5502"
  }))), _linearGradient195 || (_linearGradient195 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: -250.03,
    y1: 508.39,
    x2: -249.97,
    y2: 508.33,
    gradientTransform: "matrix(0, -319, -352, 0, 179069.23, -79682.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e66d05"
  }))), _linearGradient196 || (_linearGradient196 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: -248.17,
    y1: 508.42,
    x2: -248.11,
    y2: 508.36,
    gradientTransform: "matrix(0, -495, -209, 0, 106329.23, -122751.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb6101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e27303"
  }))), _linearGradient197 || (_linearGradient197 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: -248.73,
    y1: 509.91,
    x2: -248.67,
    y2: 509.85,
    gradientTransform: "matrix(0, -445, -135, 0, 68898.23, -110601.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48e15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de7106"
  }))), _linearGradient198 || (_linearGradient198 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: -248.84,
    y1: 506.96,
    x2: -248.78,
    y2: 506.9,
    gradientTransform: "matrix(0, -429, -288, 0, 146066.23, -106681.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f27804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d46603"
  }))), _linearGradient199 || (_linearGradient199 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: -248.69,
    y1: 505.43,
    x2: -248.64,
    y2: 505.38,
    gradientTransform: "matrix(0, -443, -336, 0, 169866.23, -110089.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f07b06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6770a"
  }))), _linearGradient200 || (_linearGradient200 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: -248.68,
    y1: 505.37,
    x2: -248.62,
    y2: 505.32,
    gradientTransform: "matrix(0, -443, -255, 0, 128899.23, -110089.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db6500"
  }))), _linearGradient201 || (_linearGradient201 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: -248.71,
    y1: 506.1,
    x2: -248.66,
    y2: 506.04,
    gradientTransform: "matrix(0, -445, -280, 0, 141754.23, -110601.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e67a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d25a00"
  }))), _linearGradient202 || (_linearGradient202 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: -260.11,
    y1: 505.38,
    x2: -260.05,
    y2: 505.32,
    gradientTransform: "matrix(0, -110, -255, 0, 128899.23, -28555.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd6601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d65c00"
  }))), _linearGradient203 || (_linearGradient203 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: -252.4,
    y1: 505.81,
    x2: -252.34,
    y2: 505.75,
    gradientTransform: "matrix(0, -252, -323, 0, 163426.23, -63546.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e76402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e26501"
  }))), _linearGradient204 || (_linearGradient204 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: -253.09,
    y1: 506.75,
    x2: -253.02,
    y2: 506.69,
    gradientTransform: "matrix(0, -230, -309, 0, 156650.23, -58156.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e06600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f27500"
  }))), _linearGradient205 || (_linearGradient205 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: -249.37,
    y1: 505.82,
    x2: -249.31,
    y2: 505.76,
    gradientTransform: "matrix(0, -493, -488, 0, 246909.23, -122885.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f67300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed6e00"
  }))), _linearGradient206 || (_linearGradient206 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: -250.16,
    y1: 505.82,
    x2: -250.1,
    y2: 505.76,
    gradientTransform: "matrix(0, -444, -488, 0, 246909.23, -111030.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e96c00"
  }))), _linearGradient207 || (_linearGradient207 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: -251.28,
    y1: 513.67,
    x2: -251.22,
    y2: 513.61,
    gradientTransform: "matrix(0, -350, -84, 0, 43209.23, -87906.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb7401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb7802"
  }))), _linearGradient208 || (_linearGradient208 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: -250.15,
    y1: 506.78,
    x2: -250.09,
    y2: 506.72,
    gradientTransform: "matrix(0, -444, -309, 0, 156657.23, -111030.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f27301"
  }))), _linearGradient209 || (_linearGradient209 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: -253.18,
    y1: 518.34,
    x2: -253.12,
    y2: 518.28,
    gradientTransform: "matrix(0, -310, -241, 0, 125161.23, -78468.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f28b06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fba117"
  }))), _linearGradient210 || (_linearGradient210 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: -260.99,
    y1: 509.51,
    x2: -260.93,
    y2: 509.45,
    gradientTransform: "matrix(0, -158, -571, 0, 291151.23, -41228.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa217"
  }))), _linearGradient211 || (_linearGradient211 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: -252.95,
    y1: 509.89,
    x2: -252.89,
    y2: 509.83,
    gradientTransform: "matrix(0, -300, -441, 0, 225047.23, -75858.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9a14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffaf20"
  }))), _linearGradient212 || (_linearGradient212 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: -244.87,
    y1: 506.63,
    x2: -244.81,
    y2: 506.57,
    gradientTransform: "matrix(0, -291, -913, 0, 462729.23, -71083.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b45e08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#993b00"
  }))), _linearGradient213 || (_linearGradient213 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: -244.68,
    y1: 517.47,
    x2: -244.62,
    y2: 517.41,
    gradientTransform: "matrix(0, -127, -235, 0, 121825.23, -30915.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a23d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#973500"
  }))), _linearGradient214 || (_linearGradient214 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: -249.82,
    y1: 518.49,
    x2: -249.76,
    y2: 518.43,
    gradientTransform: "matrix(0, -58, -208, 0, 108058.23, -14352.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d65c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d15700"
  }))), _linearGradient215 || (_linearGradient215 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: -247.83,
    y1: 597.54,
    x2: -247.77,
    y2: 597.48,
    gradientTransform: "matrix(0, -121, -32, 0, 19331.23, -29850.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd5c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d15100"
  }))), _linearGradient216 || (_linearGradient216 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: -247.67,
    y1: 519.18,
    x2: -247.61,
    y2: 519.13,
    gradientTransform: "matrix(0, -142, -199, 0, 103531.23, -35031.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d95e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d45700"
  }))), _linearGradient217 || (_linearGradient217 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: -248.79,
    y1: 531.98,
    x2: -248.73,
    y2: 531.92,
    gradientTransform: "matrix(0, -99, -107, 0, 57131.23, -24496.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d25500"
  }))), _linearGradient218 || (_linearGradient218 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: -250.79,
    y1: 528.6,
    x2: -250.73,
    y2: 528.53,
    gradientTransform: "matrix(0, -205, -106, 0, 56215.23, -51318.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d25400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d15700"
  }))), _linearGradient219 || (_linearGradient219 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: -250.78,
    y1: 513.7,
    x2: -250.72,
    y2: 513.64,
    gradientTransform: "matrix(0, -205, -273, 0, 140428.23, -51318.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c14900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db6000"
  }))), _linearGradient220 || (_linearGradient220 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: -251.57,
    y1: 520.64,
    x2: -251.51,
    y2: 520.58,
    gradientTransform: "matrix(0, -180, -154, 0, 80359.23, -45193.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c34d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d95d00"
  }))), _linearGradient221 || (_linearGradient221 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: -247.84,
    y1: 511.37,
    x2: -247.78,
    y2: 511.31,
    gradientTransform: "matrix(0, -568, -367, 0, 187865.23, -140682.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e46800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb7503"
  }))), _linearGradient222 || (_linearGradient222 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: -256.68,
    y1: 519.28,
    x2: -256.62,
    y2: 519.22,
    gradientTransform: "matrix(0, -101, -167, 0, 86898.23, -25840.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e46201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e76801"
  }))), _linearGradient223 || (_linearGradient223 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: -250.28,
    y1: 512.18,
    x2: -250.22,
    y2: 512.11,
    gradientTransform: "matrix(0, -274, -297, 0, 152288.23, -68497.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e06200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7300"
  }))), _linearGradient224 || (_linearGradient224 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: -246.35,
    y1: 504.49,
    x2: -246.29,
    y2: 504.43,
    gradientTransform: "matrix(0, -301, -284, 0, 143290.23, -74005.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac3800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a73600"
  }))), _linearGradient225 || (_linearGradient225 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: -246.31,
    y1: 503.93,
    x2: -246.25,
    y2: 503.87,
    gradientTransform: "matrix(0, -329, -376, 0, 189477.23, -80893.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa3f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa4000"
  }))), _linearGradient226 || (_linearGradient226 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: -247.21,
    y1: 505.86,
    x2: -247.15,
    y2: 505.8,
    gradientTransform: "matrix(0, -246, -173, 0, 87541.23, -60679.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b64200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b64200"
  }))), _linearGradient227 || (_linearGradient227 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: -248.71,
    y1: 503.92,
    x2: -248.65,
    y2: 503.85,
    gradientTransform: "matrix(0, -143, -376, 0, 189477.23, -35438.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ad4300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad4000"
  }))), _linearGradient228 || (_linearGradient228 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: -248.05,
    y1: 503.93,
    x2: -247.98,
    y2: 503.87,
    gradientTransform: "matrix(0, -190, -436, 0, 219719.23, -47000.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c85100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a93900"
  }))), _linearGradient229 || (_linearGradient229 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: -248.04,
    y1: 505.86,
    x2: -247.98,
    y2: 505.8,
    gradientTransform: "matrix(0, -190, -173, 0, 87541.23, -47000.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be4b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a53900"
  }))), _linearGradient230 || (_linearGradient230 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: -245.08,
    y1: 503.94,
    x2: -245.02,
    y2: 503.88,
    gradientTransform: "matrix(0, -356, -1582, 0, 797253.23, -87073.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a14700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f4302"
  }))), _linearGradient231 || (_linearGradient231 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: -240.08,
    y1: 505.3,
    x2: -240.02,
    y2: 505.24,
    gradientTransform: "matrix(0, -56, -1070, 0, 540787.23, -13273.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c06408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a94e02"
  }))), _linearGradient232 || (_linearGradient232 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: -244.93,
    y1: 509.64,
    x2: -244.86,
    y2: 509.57,
    gradientTransform: "matrix(0, -301, -214, 0, 109149.23, -73551.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb5506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b95e07"
  }))), _linearGradient233 || (_linearGradient233 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: -245.07,
    y1: 504.96,
    x2: -245.01,
    y2: 504.89,
    gradientTransform: "matrix(0, -348, -744, 0, 375739.23, -85113.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c15a03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be6005"
  }))), _linearGradient234 || (_linearGradient234 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: -243.52,
    y1: 506.25,
    x2: -243.46,
    y2: 506.19,
    gradientTransform: "matrix(0, -131, -626, 0, 317011.23, -31731.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#903800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b15803"
  }))), _linearGradient235 || (_linearGradient235 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: -244.83,
    y1: 515.28,
    x2: -244.77,
    y2: 515.22,
    gradientTransform: "matrix(0, -279, -118, 0, 60899.23, -68139.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a3300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994102"
  }))), _linearGradient236 || (_linearGradient236 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: -243.53,
    y1: 505.59,
    x2: -243.47,
    y2: 505.54,
    gradientTransform: "matrix(0, -131, -877, 0, 443515.23, -31731.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc5a04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c36c07"
  }))), _linearGradient237 || (_linearGradient237 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: -252.67,
    y1: 505.91,
    x2: -252.61,
    y2: 505.85,
    gradientTransform: "matrix(0, -204, -123, 0, 62248.23, -51475.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b64e01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd5e01"
  }))), _linearGradient238 || (_linearGradient238 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: -250.87,
    y1: 504,
    x2: -250.81,
    y2: 503.94,
    gradientTransform: "matrix(0, -292, -336, 0, 169354.23, -73186.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b44f00"
  }))), _linearGradient239 || (_linearGradient239 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: -252.61,
    y1: 505.9,
    x2: -252.55,
    y2: 505.84,
    gradientTransform: "matrix(0, -215, -123, 0, 62248.23, -54244.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d26601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c65c00"
  }))), _linearGradient240 || (_linearGradient240 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: -250.87,
    y1: 505.94,
    x2: -250.81,
    y2: 505.88,
    gradientTransform: "matrix(0, -292, -121, 0, 61240.23, -73186.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c86100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c65c00"
  }))), _linearGradient241 || (_linearGradient241 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: -250.18,
    y1: 510.64,
    x2: -250.12,
    y2: 510.58,
    gradientTransform: "matrix(0, -393, -446, 0, 227956.23, -98264.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed7b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa211"
  }))), _linearGradient242 || (_linearGradient242 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: -248.64,
    y1: 512.82,
    x2: -248.58,
    y2: 512.76,
    gradientTransform: "matrix(0, -622, -354, 0, 181759.23, -154598.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f47f03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f98d05"
  }))), _linearGradient243 || (_linearGradient243 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: -253.49,
    y1: 521.34,
    x2: -253.43,
    y2: 521.28,
    gradientTransform: "matrix(0, -247, -171, 0, 89356.23, -62573.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9e0f"
  }))), _linearGradient244 || (_linearGradient244 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: -249.71,
    y1: 504.9,
    x2: -249.64,
    y2: 504.84,
    gradientTransform: "matrix(0, -435, -405, 0, 204519.23, -108564.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d65900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e66800"
  }))), _linearGradient245 || (_linearGradient245 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: -249.7,
    y1: 505.82,
    x2: -249.64,
    y2: 505.76,
    gradientTransform: "matrix(0, -435, -323, 0, 163426.23, -108564.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d15400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e66800"
  }))), _linearGradient246 || (_linearGradient246 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: -250.31,
    y1: 504.6,
    x2: -250.25,
    y2: 504.54,
    gradientTransform: "matrix(0, -384, -488, 0, 246268.23, -96069.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d25800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f27503"
  }))), _linearGradient247 || (_linearGradient247 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: -249.17,
    y1: 504.59,
    x2: -249.11,
    y2: 504.53,
    gradientTransform: "matrix(0, -550, -488, 0, 246268.23, -136996.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb8104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9e0c"
  }))), _linearGradient248 || (_linearGradient248 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: -251.87,
    y1: 508.88,
    x2: -251.81,
    y2: 508.82,
    gradientTransform: "matrix(0, -315, -153, 0, 77916.23, -79296.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e46900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f97500"
  }))), _linearGradient249 || (_linearGradient249 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: -253.85,
    y1: 505.63,
    x2: -253.79,
    y2: 505.58,
    gradientTransform: "matrix(0, -257, -316, 0, 159821.23, -65211.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa1"
  }))), _linearGradient250 || (_linearGradient250 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: -250.26,
    y1: 503.83,
    x2: -250.2,
    y2: 503.77,
    gradientTransform: "matrix(0, -222, -467, 0, 235293.23, -55462.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c35100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b14300"
  }))), _linearGradient251 || (_linearGradient251 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: -247.76,
    y1: 503.61,
    x2: -247.7,
    y2: 503.54,
    gradientTransform: "matrix(0, -534, -190, 0, 95684.23, -132214.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d46400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b24d00"
  }))), _linearGradient252 || (_linearGradient252 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: -249.55,
    y1: 504.36,
    x2: -249.48,
    y2: 504.3,
    gradientTransform: "matrix(0, -269, -278, 0, 140226.23, -67032.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a73c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad4200"
  }))), _linearGradient253 || (_linearGradient253 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: -251.28,
    y1: 504.51,
    x2: -251.22,
    y2: 504.45,
    gradientTransform: "matrix(0, -219, -197, 0, 99402.23, -54946.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f3a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac4300"
  }))), _linearGradient254 || (_linearGradient254 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: -250.09,
    y1: 504.58,
    x2: -250.04,
    y2: 504.52,
    gradientTransform: "matrix(0, -282, -176, 0, 88818.23, -70444.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#943700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#af4700"
  }))), _linearGradient255 || (_linearGradient255 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: -249.5,
    y1: 504.03,
    x2: -249.44,
    y2: 503.97,
    gradientTransform: "matrix(0, -329, -246, 0, 123994.23, -82006.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c65800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b64b00"
  }))), _linearGradient256 || (_linearGradient256 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: -249.51,
    y1: 503.6,
    x2: -249.45,
    y2: 503.54,
    gradientTransform: "matrix(0, -329, -190, 0, 95684.23, -82006.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a95001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b14e01"
  }))), _linearGradient257 || (_linearGradient257 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: -245.54,
    y1: 509.97,
    x2: -245.48,
    y2: 509.91,
    gradientTransform: "matrix(0, -487, -402, 0, 205175.23, -119415.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c35807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a23400"
  }))), _linearGradient258 || (_linearGradient258 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: -245.54,
    y1: 507.91,
    x2: -245.48,
    y2: 507.85,
    gradientTransform: "matrix(0, -487, -530, 0, 269336.23, -119415.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db770a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c15302"
  }))), _linearGradient259 || (_linearGradient259 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: -246.52,
    y1: 515.5,
    x2: -246.46,
    y2: 515.43,
    gradientTransform: "matrix(0, -256, -223, 0, 115138.23, -62964.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b14400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#af3d00"
  }))), _linearGradient260 || (_linearGradient260 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: -246.72,
    y1: 507.9,
    x2: -246.66,
    y2: 507.84,
    gradientTransform: "matrix(0, -316, -530, 0, 269336.23, -77824.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf5802"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b13a00"
  }))), _linearGradient261 || (_linearGradient261 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: -246.58,
    y1: 510.8,
    x2: -246.52,
    y2: 510.74,
    gradientTransform: "matrix(0, -403, -352, 0, 179968.23, -99238.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c14800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b94100"
  }))), _linearGradient262 || (_linearGradient262 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: -246.59,
    y1: 510.19,
    x2: -246.53,
    y2: 510.13,
    gradientTransform: "matrix(0, -403, -360, 0, 183826.23, -99238.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b74100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b23f00"
  }))), _linearGradient263 || (_linearGradient263 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: -248.07,
    y1: 519.2,
    x2: -248.01,
    y2: 519.14,
    gradientTransform: "matrix(0, -344, -229, 0, 119142.23, -85225.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f99005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9307"
  }))), _linearGradient264 || (_linearGradient264 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: -246.92,
    y1: 526.6,
    x2: -246.85,
    y2: 526.54,
    gradientTransform: "matrix(0, -784, -157, 0, 82926.23, -193465.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd9c0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa711"
  }))), _linearGradient265 || (_linearGradient265 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: -249.57,
    y1: 535.64,
    x2: -249.51,
    y2: 535.58,
    gradientTransform: "matrix(0, -229, -109, 0, 58625.23, -57050.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8a02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8b04"
  }))), _linearGradient266 || (_linearGradient266 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: -247.62,
    y1: 511.64,
    x2: -247.56,
    y2: 511.58,
    gradientTransform: "matrix(0, -597, -414, 0, 212040.23, -147739.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9006"
  }))), _linearGradient267 || (_linearGradient267 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: -247.61,
    y1: 514.07,
    x2: -247.55,
    y2: 514.01,
    gradientTransform: "matrix(0, -641, -336, 0, 172962.23, -158631.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa10c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8d08"
  }))), _linearGradient268 || (_linearGradient268 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: -247.62,
    y1: 511.64,
    x2: -247.56,
    y2: 511.57,
    gradientTransform: "matrix(0, -641, -414, 0, 212040.23, -158631.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9c04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb8a03"
  }))), _linearGradient269 || (_linearGradient269 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: -245.64,
    y1: 518.06,
    x2: -245.58,
    y2: 518,
    gradientTransform: "matrix(0, -160, -225, 0, 116785.23, -39148.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a23c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a73d00"
  }))), _linearGradient270 || (_linearGradient270 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: -245.8,
    y1: 519.78,
    x2: -245.74,
    y2: 519.72,
    gradientTransform: "matrix(0, -296, -191, 0, 99490.23, -72604.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b64900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c14e00"
  }))), _linearGradient271 || (_linearGradient271 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: -245.97,
    y1: 516.19,
    x2: -245.91,
    y2: 516.12,
    gradientTransform: "matrix(0, -210, -262, 0, 135465.23, -51501.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c04f00"
  }))), _linearGradient272 || (_linearGradient272 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: -246.61,
    y1: 516.2,
    x2: -246.55,
    y2: 516.13,
    gradientTransform: "matrix(0, -151, -262, 0, 135465.23, -37094.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e46900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c04d00"
  }))), _linearGradient273 || (_linearGradient273 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: -246.62,
    y1: 518.49,
    x2: -246.56,
    y2: 518.43,
    gradientTransform: "matrix(0, -151, -208, 0, 108058.23, -37094.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c85100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b64700"
  }))), _linearGradient274 || (_linearGradient274 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    x1: -250.64,
    y1: 517.57,
    x2: -250.58,
    y2: 517.51,
    gradientTransform: "matrix(0, -434, -222, 0, 115112.23, -108743.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa112"
  }))), _linearGradient275 || (_linearGradient275 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    x1: -250.63,
    y1: 512.83,
    x2: -250.57,
    y2: 512.76,
    gradientTransform: "matrix(0, -434, -354, 0, 181759.23, -108743.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9c0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f88e09"
  }))), _linearGradient276 || (_linearGradient276 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    x1: -251.86,
    y1: 515.18,
    x2: -251.8,
    y2: 515.12,
    gradientTransform: "matrix(0, -355, -266, 0, 137244.23, -89388.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa917"
  }))), _linearGradient277 || (_linearGradient277 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    x1: -256.85,
    y1: 514.99,
    x2: -256.8,
    y2: 514.93,
    gradientTransform: "matrix(0, -205, -293, 0, 151118.23, -52638.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08b07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9970e"
  }))), _linearGradient278 || (_linearGradient278 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    x1: -261.48,
    y1: 515.16,
    x2: -261.42,
    y2: 515.1,
    gradientTransform: "matrix(0, -153, -266, 0, 137244.23, -39996.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb71d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa211"
  }))), _linearGradient279 || (_linearGradient279 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    x1: -261.69,
    y1: 512.46,
    x2: -261.62,
    y2: 512.39,
    gradientTransform: "matrix(0, -151, -372, 0, 190855.23, -39506.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8910c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff990d"
  }))), _linearGradient280 || (_linearGradient280 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    x1: -259.15,
    y1: 510.55,
    x2: -259.09,
    y2: 510.49,
    gradientTransform: "matrix(0, -175, -397, 0, 202871.23, -45339.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffad1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbc26"
  }))), _linearGradient281 || (_linearGradient281 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    x1: -259.16,
    y1: 508.86,
    x2: -259.1,
    y2: 508.8,
    gradientTransform: "matrix(0, -175, -458, 0, 233218.23, -45339.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb726"
  }))), _linearGradient282 || (_linearGradient282 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    x1: -261.47,
    y1: 509.08,
    x2: -261.41,
    y2: 509.02,
    gradientTransform: "matrix(0, -153, -523, 0, 266436.23, -39996.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc12c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbc26"
  }))), _linearGradient283 || (_linearGradient283 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    x1: -298.49,
    y1: 504.2,
    x2: -298.43,
    y2: 504.14,
    gradientTransform: "matrix(0, -47, -2764, 0, 1393659.23, -14026.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbc26"
  }))), _linearGradient284 || (_linearGradient284 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    x1: -250.58,
    y1: 508.26,
    x2: -250.52,
    y2: 508.2,
    gradientTransform: "matrix(0, -345, -423, 0, 215121.23, -86397.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8203"
  }))), _linearGradient285 || (_linearGradient285 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    x1: -250.59,
    y1: 510.05,
    x2: -250.53,
    y2: 509.98,
    gradientTransform: "matrix(0, -345, -267, 0, 136298.23, -86397.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f47506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd7c02"
  }))), _linearGradient286 || (_linearGradient286 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    x1: -250.18,
    y1: 508.25,
    x2: -250.12,
    y2: 508.19,
    gradientTransform: "matrix(0, -425, -423, 0, 215121.23, -106275.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8e0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa912"
  }))), _linearGradient287 || (_linearGradient287 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-287",
    x1: -252.65,
    y1: 512.1,
    x2: -252.59,
    y2: 512.05,
    gradientTransform: "matrix(0, -281, -199, 0, 102026.23, -70952.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8a03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8e03"
  }))), _linearGradient288 || (_linearGradient288 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-288",
    x1: -252.86,
    y1: 507.87,
    x2: -252.8,
    y2: 507.81,
    gradientTransform: "matrix(0, -278, -445, 0, 226119.23, -70260.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f47500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9409"
  }))), _linearGradient289 || (_linearGradient289 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-289",
    x1: -256.2,
    y1: 507.54,
    x2: -256.14,
    y2: 507.48,
    gradientTransform: "matrix(0, -217, -398, 0, 202103.23, -55577.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa40d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb91c"
  }))), _linearGradient290 || (_linearGradient290 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-290",
    x1: -256.2,
    y1: 512.1,
    x2: -256.14,
    y2: 512.03,
    gradientTransform: "matrix(0, -217, -161, 0, 82542.23, -55577.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb21c"
  }))), _linearGradient291 || (_linearGradient291 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-291",
    x1: -259.8,
    y1: 506.12,
    x2: -259.73,
    y2: 506.06,
    gradientTransform: "matrix(0, -164, -686, 0, 347303.23, -42592.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb41c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc12a"
  }))), _linearGradient292 || (_linearGradient292 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-292",
    x1: -270.5,
    y1: 506.24,
    x2: -270.45,
    y2: 506.18,
    gradientTransform: "matrix(0, -95, -458, 0, 231933.23, -25687.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa40f"
  }))), _linearGradient293 || (_linearGradient293 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-293",
    x1: -270.78,
    y1: 505.76,
    x2: -270.72,
    y2: 505.7,
    gradientTransform: "matrix(0, -94, -827, 0, 418367.23, -25442.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcb35"
  }))), _linearGradient294 || (_linearGradient294 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-294",
    x1: -270.76,
    y1: 505.13,
    x2: -270.7,
    y2: 505.07,
    gradientTransform: "matrix(0, -96, -1285, 0, 649199.23, -25984.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbe2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcb31"
  }))), _linearGradient295 || (_linearGradient295 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-295",
    x1: -280.03,
    y1: 504.74,
    x2: -279.97,
    y2: 504.68,
    gradientTransform: "matrix(0, -71, -865, 0, 436654.23, -19876.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffaa0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb417"
  }))), _linearGradient296 || (_linearGradient296 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-296",
    x1: -272.86,
    y1: 504.26,
    x2: -272.8,
    y2: 504.19,
    gradientTransform: "matrix(0, -90, -2241, 0, 1130067.23, -24552.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd23b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbc22"
  }))), _linearGradient297 || (_linearGradient297 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-297",
    x1: -272.89,
    y1: 504.6,
    x2: -272.78,
    y2: 504.5,
    gradientTransform: "matrix(0, -90, -956, 0, 482427.23, -24552.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffaf0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb71a"
  }))), _linearGradient298 || (_linearGradient298 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-298",
    x1: -249.05,
    y1: 527.42,
    x2: -248.99,
    y2: 527.36,
    gradientTransform: "matrix(0, -205, -148, 0, 78301.23, -50941.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f68d01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f48200"
  }))), _linearGradient299 || (_linearGradient299 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-299",
    x1: -250.47,
    y1: 597.19,
    x2: -250.41,
    y2: 597.13,
    gradientTransform: "matrix(0, -179, -37, 0, 22337.23, -44732.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f67f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f27a00"
  }))), _linearGradient300 || (_linearGradient300 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-300",
    x1: -250.48,
    y1: 512.25,
    x2: -250.42,
    y2: 512.19,
    gradientTransform: "matrix(0, -179, -377, 0, 193340.23, -44732.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf5800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e46c00"
  }))), _linearGradient301 || (_linearGradient301 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-301",
    x1: -248.82,
    y1: 518.94,
    x2: -248.76,
    y2: 518.88,
    gradientTransform: "matrix(0, -213, -227, 0, 118038.23, -52883.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f87f01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb8b01"
  }))), _linearGradient302 || (_linearGradient302 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-302",
    x1: -247.96,
    y1: 512.26,
    x2: -247.9,
    y2: 512.2,
    gradientTransform: "matrix(0, -306, -377, 0, 193340.23, -75761.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb6c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e96d00"
  }))), _linearGradient303 || (_linearGradient303 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-303",
    x1: -246,
    y1: 505.87,
    x2: -245.94,
    y2: 505.8,
    gradientTransform: "matrix(0, -459, -334, 0, 169006.23, -112767.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b94e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf6102"
  }))), _linearGradient304 || (_linearGradient304 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-304",
    x1: -246.02,
    y1: 505.24,
    x2: -245.95,
    y2: 505.18,
    gradientTransform: "matrix(0, -459, -325, 0, 164238.23, -112767.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a73800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c65002"
  }))), _linearGradient305 || (_linearGradient305 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-305",
    x1: -246.51,
    y1: 505.47,
    x2: -246.45,
    y2: 505.41,
    gradientTransform: "matrix(0, -300, -423, 0, 213862.23, -73812.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b14500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b24202"
  }))), _linearGradient306 || (_linearGradient306 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-306",
    x1: -247.2,
    y1: 505.75,
    x2: -247.14,
    y2: 505.69,
    gradientTransform: "matrix(0, -246, -232, 0, 117366.23, -60679.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c54e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e26602"
  }))), _linearGradient307 || (_linearGradient307 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-307",
    x1: -247.33,
    y1: 505.46,
    x2: -247.27,
    y2: 505.4,
    gradientTransform: "matrix(0, -272, -423, 0, 213862.23, -67143.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b2600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb5702"
  }))), _linearGradient308 || (_linearGradient308 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-308",
    x1: -248.28,
    y1: 505.37,
    x2: -248.23,
    y2: 505.31,
    gradientTransform: "matrix(0, -191, -352, 0, 177930.23, -47298.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d45d02"
  }))), _linearGradient309 || (_linearGradient309 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-309",
    x1: -248.83,
    y1: 516.62,
    x2: -248.77,
    y2: 516.56,
    gradientTransform: "matrix(0, -316, -184, 0, 95220.23, -78537.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e46903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd6202"
  }))), _linearGradient310 || (_linearGradient310 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-310",
    x1: -248.52,
    y1: 531.11,
    x2: -248.46,
    y2: 531.05,
    gradientTransform: "matrix(0, -357, -84, 0, 44774.23, -88623.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c64f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c54b00"
  }))), _linearGradient311 || (_linearGradient311 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-311",
    x1: -254.96,
    y1: 515.17,
    x2: -254.89,
    y2: 515.09,
    gradientTransform: "matrix(0, -127, -206, 0, 106286.23, -32297.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd6201"
  }))), _linearGradient312 || (_linearGradient312 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-312",
    x1: -264.41,
    y1: 553.5,
    x2: -264.35,
    y2: 553.44,
    gradientTransform: "matrix(0, -65, -46, 0, 25622.23, -17107.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf5401"
  }))), _linearGradient313 || (_linearGradient313 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-313",
    x1: -254.9,
    y1: 504.96,
    x2: -254.84,
    y2: 504.89,
    gradientTransform: "matrix(0, -107, -378, 0, 190904.23, -27180.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b94d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de6e04"
  }))), _linearGradient314 || (_linearGradient314 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-314",
    x1: -249.53,
    y1: 505.28,
    x2: -249.47,
    y2: 505.22,
    gradientTransform: "matrix(0, -269, -224, 0, 113207.23, -67032.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b74700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc4d00"
  }))), _linearGradient315 || (_linearGradient315 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-315",
    x1: -257.34,
    y1: 506.11,
    x2: -257.28,
    y2: 506.05,
    gradientTransform: "matrix(0, -87, -235, 0, 118975.23, -22296.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb8b0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e77806"
  }))), _linearGradient316 || (_linearGradient316 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-316",
    x1: -253.21,
    y1: 508.32,
    x2: -253.15,
    y2: 508.26,
    gradientTransform: "matrix(0, -146, -112, 0, 56970.23, -36881.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7803"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e76d01"
  }))), _linearGradient317 || (_linearGradient317 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-317",
    x1: -252.5,
    y1: 505.28,
    x2: -252.44,
    y2: 505.22,
    gradientTransform: "matrix(0, -162, -224, 0, 113207.23, -40817.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e26a01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be5000"
  }))), _linearGradient318 || (_linearGradient318 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-318",
    x1: -248.82,
    y1: 511.02,
    x2: -248.76,
    y2: 510.95,
    gradientTransform: "matrix(0, -417, -346, 0, 176984.23, -103675.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d25c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed7400"
  }))), _linearGradient319 || (_linearGradient319 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-319",
    x1: -248.73,
    y1: 511.39,
    x2: -248.67,
    y2: 511.32,
    gradientTransform: "matrix(0, -429, -367, 0, 187865.23, -106627.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e96c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd8703"
  }))), _linearGradient320 || (_linearGradient320 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-320",
    x1: -255.6,
    y1: 511.03,
    x2: -255.54,
    y2: 510.97,
    gradientTransform: "matrix(0, -149, -346, 0, 176984.23, -38021.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f87a00"
  }))), _linearGradient321 || (_linearGradient321 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-321",
    x1: -261.52,
    y1: 511.15,
    x2: -261.46,
    y2: 511.1,
    gradientTransform: "matrix(0, -101, -340, 0, 173966.23, -26356.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f27400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f98100"
  }))), _linearGradient322 || (_linearGradient322 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-322",
    x1: -253.4,
    y1: 512.65,
    x2: -253.34,
    y2: 512.59,
    gradientTransform: "matrix(0, -212, -318, 0, 163218.23, -53662.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb41a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffaa14"
  }))), _linearGradient323 || (_linearGradient323 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-323",
    x1: -253.2,
    y1: 512.96,
    x2: -253.14,
    y2: 512.9,
    gradientTransform: "matrix(0, -218, -281, 0, 144321.23, -55138.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f98701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9907"
  }))), _linearGradient324 || (_linearGradient324 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-324",
    x1: -253.18,
    y1: 540.22,
    x2: -253.12,
    y2: 540.16,
    gradientTransform: "matrix(0, -218, -76, 0, 41250.23, -55138.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa712"
  }))), _linearGradient325 || (_linearGradient325 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-325",
    x1: -247.95,
    y1: 507.51,
    x2: -247.89,
    y2: 507.45,
    gradientTransform: "matrix(0, -329, -274, 0, 139127.23, -81466.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af3f01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd6c02"
  }))), _linearGradient326 || (_linearGradient326 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-326",
    x1: -247.78,
    y1: 506.16,
    x2: -247.72,
    y2: 506.1,
    gradientTransform: "matrix(0, -362, -331, 0, 167594.23, -89584.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b24501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7f08"
  }))), _linearGradient327 || (_linearGradient327 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-327",
    x1: -250.51,
    y1: 509.02,
    x2: -250.45,
    y2: 508.96,
    gradientTransform: "matrix(0, -196, -204, 0, 103917.23, -49001.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf6200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d76a02"
  }))), _linearGradient328 || (_linearGradient328 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-328",
    x1: -249.54,
    y1: 506.16,
    x2: -249.48,
    y2: 506.1,
    gradientTransform: "matrix(0, -270, -331, 0, 167594.23, -67281.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99117"
  }))), _linearGradient329 || (_linearGradient329 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-329",
    x1: -249.33,
    y1: 509.44,
    x2: -249.27,
    y2: 509.38,
    gradientTransform: "matrix(0, -286, -170, 0, 86673.23, -71217.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e97a08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97c0a"
  }))), _linearGradient330 || (_linearGradient330 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-330",
    x1: -249.34,
    y1: 507.29,
    x2: -249.28,
    y2: 507.22,
    gradientTransform: "matrix(0, -286, -243, 0, 123330.23, -71217.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb9c20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb840f"
  }))), _linearGradient331 || (_linearGradient331 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-331",
    x1: -244.12,
    y1: 506.09,
    x2: -244.06,
    y2: 506.03,
    gradientTransform: "matrix(0, -176, -1143, 0, 578649.23, -42793.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b45c08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#933800"
  }))), _linearGradient332 || (_linearGradient332 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-332",
    x1: -237.03,
    y1: 505.73,
    x2: -236.97,
    y2: 505.67,
    gradientTransform: "matrix(0, -37, -1377, 0, 696585.23, -8599.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b45e08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974400"
  }))), _linearGradient333 || (_linearGradient333 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-333",
    x1: -244.89,
    y1: 518.17,
    x2: -244.83,
    y2: 518.11,
    gradientTransform: "matrix(0, -266, -230, 0, 119410.23, -64970.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#933400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#973900"
  }))), _linearGradient334 || (_linearGradient334 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-334",
    x1: -244.9,
    y1: 514.13,
    x2: -244.84,
    y2: 514.06,
    gradientTransform: "matrix(0, -300, -334, 0, 171956.23, -73300.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a24b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e3f00"
  }))), _linearGradient335 || (_linearGradient335 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-335",
    x1: -250.01,
    y1: 518.46,
    x2: -249.95,
    y2: 518.4,
    gradientTransform: "matrix(0, -167, -196, 0, 101819.23, -41639.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d45401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e06000"
  }))), _linearGradient336 || (_linearGradient336 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-336",
    x1: -248.69,
    y1: 524.47,
    x2: -248.63,
    y2: 524.41,
    gradientTransform: "matrix(0, -249, -141, 0, 74154.23, -61811.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b94100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf5300"
  }))), _linearGradient337 || (_linearGradient337 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-337",
    x1: -249.46,
    y1: 542.63,
    x2: -249.4,
    y2: 542.57,
    gradientTransform: "matrix(0, -197, -73, 0, 39809.23, -49036.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c04a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e26500"
  }))), _linearGradient338 || (_linearGradient338 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-338",
    x1: -256.06,
    y1: 522.55,
    x2: -256,
    y2: 522.49,
    gradientTransform: "matrix(0, -82, -152, 0, 79625.23, -20896.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e96c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d75a00"
  }))), _linearGradient339 || (_linearGradient339 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-339",
    x1: -248.37,
    y1: 516.24,
    x2: -248.31,
    y2: 516.18,
    gradientTransform: "matrix(0, -317, -135, 0, 69812.23, -78624.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb7002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d76204"
  }))), _linearGradient340 || (_linearGradient340 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-340",
    x1: -248.91,
    y1: 510.35,
    x2: -248.85,
    y2: 510.29,
    gradientTransform: "matrix(0, -303, -230, 0, 117488.23, -75319.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd6908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c55302"
  }))), _linearGradient341 || (_linearGradient341 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-341",
    x1: -249.4,
    y1: 523.69,
    x2: -249.34,
    y2: 523.63,
    gradientTransform: "matrix(0, -268, -84, 0, 44108.23, -66744.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca5804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b94902"
  }))), _linearGradient342 || (_linearGradient342 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-342",
    x1: -247.56,
    y1: 510.94,
    x2: -247.49,
    y2: 510.88,
    gradientTransform: "matrix(0, -365, -226, 0, 115585.23, -90241.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e27404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e46c03"
  }))), _linearGradient343 || (_linearGradient343 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-343",
    x1: -247.55,
    y1: 511.17,
    x2: -247.49,
    y2: 511.11,
    gradientTransform: "matrix(0, -365, -204, 0, 104384.23, -90241.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef820b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9750d"
  }))), _linearGradient344 || (_linearGradient344 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-344",
    x1: 38.8,
    y1: 39.73,
    x2: 38.8,
    y2: 163.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34b3f0"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36",
    points: "198.13 98.66 204.02 88.33 186.53 92.05 198.13 98.66",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.58 55.97 241.68 17.51 236.62 52.63 255.58 55.97",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.51 63.08 25.11 46.42 1.02 63.37 5.51 63.08",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.77 82.62 179.74 80.36 162.57 75.45 175.77 82.62",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.79 55.97 155.53 44.78 162.57 75.45 132.79 55.97",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.63 51.22 170.32 39.53 174.23 37.56 177.63 51.22",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.58 55.97 241.68 17.51 257.12 0 255.58 55.97",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.63 51.22 170.32 39.53 171.8 56.59 177.63 51.22",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.53 44.78 170.32 39.53 171.8 56.59 155.53 44.78",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.85 113.8 153.16 106.17 157.71 119.39 168.85 113.8",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.55 15.36 43.49 0.9 21.78 4.52 40.55 15.36",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.13 98.66 186.53 92.05 187.04 100.58 198.13 98.66",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.53 92.05 183.65 90.64 187.04 100.58 186.53 92.05",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.85 113.8 187.04 100.58 195.44 122.27 168.85 113.8",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.53 44.78 170.32 39.53 151.17 20.78 155.53 44.78",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.32 39.53 174.23 37.56 151.17 20.78 170.32 39.53",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.23 37.56 183.14 12.93 151.17 20.78 174.23 37.56",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.04 100.58 198.13 98.66 199.28 109.79 187.04 100.58",
    style: {
      fill: "url(#linear-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.44 122.27 187.04 100.58 199.28 109.79 195.44 122.27",
    style: {
      fill: "url(#linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.43 23.61 101.66 18.24 101.27 20.56 97.43 23.61",
    style: {
      fill: "url(#linear-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.04 109.96 29.98 93.75 31.2 116.79 4.04 109.96",
    style: {
      fill: "url(#linear-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.2 116.79 29.98 93.75 38.31 119.11 31.2 116.79",
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.77 82.62 179.74 80.36 180.57 86.07 175.77 82.62",
    style: {
      fill: "url(#linear-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.79 22.42 63.86 20.44 50.99 10.96 60.79 22.42",
    style: {
      fill: "url(#linear-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.79 22.42 40.55 15.36 50.99 10.96 60.79 22.42",
    style: {
      fill: "url(#linear-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.55 15.36 43.49 0.9 50.99 10.96 40.55 15.36",
    style: {
      fill: "url(#linear-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.71 118.37 112.55 116.73 125.17 125.77 129.71 118.37",
    style: {
      fill: "url(#linear-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.95 56.25 236.62 52.63 208.05 39.93 213.95 56.25",
    style: {
      fill: "url(#linear-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.95 56.25 198.45 44.95 208.05 39.93 213.95 56.25",
    style: {
      fill: "url(#linear-gradient-29)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.3 164.06 146.3 161.46 146.82 137.23 169.3 164.06",
    style: {
      fill: "url(#linear-gradient-30)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.15 170.44 240.53 139.32 251.93 113.34 258.15 170.44",
    style: {
      fill: "url(#linear-gradient-31)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.17 20.78 148.67 11.29 127.15 15.25 151.17 20.78",
    style: {
      fill: "url(#linear-gradient-32)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.17 20.78 127.15 15.25 122.67 23.21 151.17 20.78",
    style: {
      fill: "url(#linear-gradient-33)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.27 20.56 101.66 18.24 122.67 23.21 101.27 20.56",
    style: {
      fill: "url(#linear-gradient-34)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.66 18.24 127.15 15.25 122.67 23.21 101.66 18.24",
    style: {
      fill: "url(#linear-gradient-35)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.99 10.96 75.39 6.1 49.32 2.09 50.99 10.96",
    style: {
      fill: "url(#linear-gradient-36)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.99 10.96 43.49 0.9 49.32 2.09 50.99 10.96",
    style: {
      fill: "url(#linear-gradient-37)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.86 20.44 83.66 15.13 74.82 13.95 63.86 20.44",
    style: {
      fill: "url(#linear-gradient-38)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.86 20.44 50.99 10.96 74.82 13.95 63.86 20.44",
    style: {
      fill: "url(#linear-gradient-39)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.66 15.13 75.39 6.1 74.82 13.95 83.66 15.13",
    style: {
      fill: "url(#linear-gradient-40)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.99 10.96 75.39 6.1 74.82 13.95 50.99 10.96",
    style: {
      fill: "url(#linear-gradient-41)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.43 23.61 101.27 20.56 102.81 39.48 97.43 23.61",
    style: {
      fill: "url(#linear-gradient-42)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.31 79.46 23.45 69.3 29.15 57.77 38.31 79.46",
    style: {
      fill: "url(#linear-gradient-43)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.02 53.59 30.43 51.56 29.15 57.77 29.02 53.59",
    style: {
      fill: "url(#linear-gradient-44)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.18 141.53 71.94 139.55 73.6 137.18 69.18 141.53",
    style: {
      fill: "url(#linear-gradient-45)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.18 141.53 74.88 129.16 73.6 137.18 69.18 141.53",
    style: {
      fill: "url(#linear-gradient-46)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.94 139.55 80.2 135.37 73.6 137.18 71.94 139.55",
    style: {
      fill: "url(#linear-gradient-47)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.2 135.37 74.88 129.16 73.6 137.18 80.2 135.37",
    style: {
      fill: "url(#linear-gradient-48)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.74 150.5 69.18 141.53 84.43 147.68 53.74 150.5",
    style: {
      fill: "url(#linear-gradient-49)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.24 142.66 80.2 135.37 84.43 147.68 87.24 142.66",
    style: {
      fill: "url(#linear-gradient-50)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.18 141.53 71.94 139.55 84.43 147.68 69.18 141.53",
    style: {
      fill: "url(#linear-gradient-51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.94 139.55 80.2 135.37 84.43 147.68 71.94 139.55",
    style: {
      fill: "url(#linear-gradient-52)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.63 51.22 195.63 44.62 192.1 38.8 177.63 51.22",
    style: {
      fill: "url(#linear-gradient-53)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.63 51.22 174.23 37.56 192.1 38.8 177.63 51.22",
    style: {
      fill: "url(#linear-gradient-54)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.45 44.95 195.63 44.62 192.1 38.8 198.45 44.95",
    style: {
      fill: "url(#linear-gradient-55)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.45 44.95 208.05 39.93 192.1 38.8 198.45 44.95",
    style: {
      fill: "url(#linear-gradient-56)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.05 39.93 211.38 25.98 192.1 38.8 208.05 39.93",
    style: {
      fill: "url(#linear-gradient-57)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.23 37.56 183.14 12.93 192.1 38.8 174.23 37.56",
    style: {
      fill: "url(#linear-gradient-58)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.38 25.98 183.14 12.93 192.1 38.8 211.38 25.98",
    style: {
      fill: "url(#linear-gradient-59)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.31 79.46 23.45 69.3 24.79 78.56 38.31 79.46",
    style: {
      fill: "url(#linear-gradient-60)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.28 154.4 100.83 149.26 87.69 153.16 96.28 154.4",
    style: {
      fill: "url(#linear-gradient-61)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.74 150.5 84.43 147.68 87.69 153.16 53.74 150.5",
    style: {
      fill: "url(#linear-gradient-62)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.83 149.26 87.24 142.66 87.69 153.16 100.83 149.26",
    style: {
      fill: "url(#linear-gradient-63)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.43 147.68 87.24 142.66 87.69 153.16 84.43 147.68",
    style: {
      fill: "url(#linear-gradient-64)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.46 97.87 111.27 73.98 79.37 86.8 88.46 97.87",
    style: {
      fill: "url(#linear-gradient-65)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.83 110.75 199.28 109.79 213.56 116.39 211.83 110.75",
    style: {
      fill: "url(#linear-gradient-66)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.04 130.63 216.89 128.59 213.56 116.39 210.04 130.63",
    style: {
      fill: "url(#linear-gradient-67)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.04 130.63 195.44 122.27 213.56 116.39 210.04 130.63",
    style: {
      fill: "url(#linear-gradient-68)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.44 122.27 199.28 109.79 213.56 116.39 195.44 122.27",
    style: {
      fill: "url(#linear-gradient-69)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.83 110.75 218.3 97.53 237.39 114.81 211.83 110.75",
    style: {
      fill: "url(#linear-gradient-70)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.53 139.32 251.93 113.34 237.39 114.81 240.53 139.32",
    style: {
      fill: "url(#linear-gradient-71)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.53 139.32 224.84 136.61 237.39 114.81 240.53 139.32",
    style: {
      fill: "url(#linear-gradient-72)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.84 136.61 216.89 128.59 237.39 114.81 224.84 136.61",
    style: {
      fill: "url(#linear-gradient-73)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.89 128.59 213.56 116.39 237.39 114.81 216.89 128.59",
    style: {
      fill: "url(#linear-gradient-74)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.56 116.39 211.83 110.75 237.39 114.81 213.56 116.39",
    style: {
      fill: "url(#linear-gradient-75)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.88 129.16 60.85 113.8 70.91 112.16 74.88 129.16",
    style: {
      fill: "url(#linear-gradient-76)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.88 129.16 78.02 117.07 70.91 112.16 74.88 129.16",
    style: {
      fill: "url(#linear-gradient-77)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.02 117.07 88.46 97.87 70.91 112.16 78.02 117.07",
    style: {
      fill: "url(#linear-gradient-78)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.37 86.8 111.27 73.98 101.98 59.07 79.37 86.8",
    style: {
      fill: "url(#linear-gradient-79)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.27 73.98 132.79 55.97 101.98 59.07 111.27 73.98",
    style: {
      fill: "url(#linear-gradient-80)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.37 86.8 101.98 59.07 81.86 58.85 79.37 86.8",
    style: {
      fill: "url(#linear-gradient-81)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.98 59.07 99.73 54.95 81.86 58.85 101.98 59.07",
    style: {
      fill: "url(#linear-gradient-82)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.73 54.95 83.21 51.45 81.86 58.85 99.73 54.95",
    style: {
      fill: "url(#linear-gradient-83)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.42 53.2 83.21 51.45 81.86 58.85 63.42 53.2",
    style: {
      fill: "url(#linear-gradient-84)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.73 54.95 83.21 51.45 97.36 46.76 99.73 54.95",
    style: {
      fill: "url(#linear-gradient-85)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.73 54.95 102.81 39.48 97.36 46.76 99.73 54.95",
    style: {
      fill: "url(#linear-gradient-86)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.21 51.45 97.43 23.61 97.36 46.76 83.21 51.45",
    style: {
      fill: "url(#linear-gradient-87)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.81 39.48 97.43 23.61 97.36 46.76 102.81 39.48",
    style: {
      fill: "url(#linear-gradient-88)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.17 125.77 112.55 116.73 100.25 126.9 125.17 125.77",
    style: {
      fill: "url(#linear-gradient-89)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.94 170.61 169.3 164.06 195.05 142.88 169.94 170.61",
    style: {
      fill: "url(#linear-gradient-90)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.94 170.61 221.7 154.18 195.05 142.88 169.94 170.61",
    style: {
      fill: "url(#linear-gradient-91)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.7 154.18 211.51 137.46 195.05 142.88 221.7 154.18",
    style: {
      fill: "url(#linear-gradient-92)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.51 137.46 210.04 130.63 195.05 142.88 211.51 137.46",
    style: {
      fill: "url(#linear-gradient-93)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.2 116.79 4.04 109.96 3.27 119.44 31.2 116.79",
    style: {
      fill: "url(#linear-gradient-94)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.05 142.88 210.04 130.63 191.4 128.42 195.05 142.88",
    style: {
      fill: "url(#linear-gradient-95)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.04 130.63 195.44 122.27 191.4 128.42 210.04 130.63",
    style: {
      fill: "url(#linear-gradient-96)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.44 122.27 168.85 113.8 191.4 128.42 195.44 122.27",
    style: {
      fill: "url(#linear-gradient-97)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.83 149.26 87.24 142.66 96.02 138.03 100.83 149.26",
    style: {
      fill: "url(#linear-gradient-98)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.24 142.66 80.2 135.37 96.02 138.03 87.24 142.66",
    style: {
      fill: "url(#linear-gradient-99)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.2 135.37 100.25 126.9 96.02 138.03 80.2 135.37",
    style: {
      fill: "url(#linear-gradient-100)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.28 154.4 100.83 149.26 109.47 157.96 96.28 154.4",
    style: {
      fill: "url(#linear-gradient-101)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.83 167.62 141.5 162.76 109.47 157.96 103.83 167.62",
    style: {
      fill: "url(#linear-gradient-102)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.83 167.62 96.28 154.4 109.47 157.96 103.83 167.62",
    style: {
      fill: "url(#linear-gradient-103)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.98 59.07 132.79 55.97 115.69 39.08 101.98 59.07",
    style: {
      fill: "url(#linear-gradient-104)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.98 59.07 99.73 54.95 115.69 39.08 101.98 59.07",
    style: {
      fill: "url(#linear-gradient-105)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.73 54.95 102.81 39.48 115.69 39.08 99.73 54.95",
    style: {
      fill: "url(#linear-gradient-106)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.81 39.48 101.27 20.56 115.69 39.08 102.81 39.48",
    style: {
      fill: "url(#linear-gradient-107)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.67 23.21 101.27 20.56 115.69 39.08 122.67 23.21",
    style: {
      fill: "url(#linear-gradient-108)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.85 113.8 153.16 106.17 166.42 96.97 168.85 113.8",
    style: {
      fill: "url(#linear-gradient-109)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.85 113.8 187.04 100.58 166.42 96.97 168.85 113.8",
    style: {
      fill: "url(#linear-gradient-110)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.16 106.17 161.04 76.81 166.42 96.97 153.16 106.17",
    style: {
      fill: "url(#linear-gradient-111)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.04 100.58 183.65 90.64 166.42 96.97 187.04 100.58",
    style: {
      fill: "url(#linear-gradient-112)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.65 90.64 180.57 86.07 166.42 96.97 183.65 90.64",
    style: {
      fill: "url(#linear-gradient-113)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.57 86.07 175.77 82.62 166.42 96.97 180.57 86.07",
    style: {
      fill: "url(#linear-gradient-114)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.06 170.61 3.14 125.94 0.06 94.2 0.06 170.61",
    style: {
      fill: "url(#linear-gradient-115)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.04 109.96 29.98 93.75 0.06 94.2 4.04 109.96",
    style: {
      fill: "url(#linear-gradient-116)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.14 125.94 3.27 119.44 0.06 94.2 3.14 125.94",
    style: {
      fill: "url(#linear-gradient-117)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.27 119.44 4.04 109.96 0.06 94.2 3.27 119.44",
    style: {
      fill: "url(#linear-gradient-118)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1.02 63.37 5.51 63.08 0 64.04 1.02 63.37",
    style: {
      fill: "url(#linear-gradient-119)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.93 113.34 243.54 101.77 258.21 108.26 251.93 113.34",
    style: {
      fill: "url(#linear-gradient-120)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.15 170.44 251.93 113.34 258.21 108.26 258.15 170.44",
    style: {
      fill: "url(#linear-gradient-121)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.58 55.97 236.62 52.63 258.15 63.99 255.58 55.97",
    style: {
      fill: "url(#linear-gradient-122)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.58 55.97 257.12 0 258.15 63.99 255.58 55.97",
    style: {
      fill: "url(#linear-gradient-123)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.2 135.37 74.88 129.16 96.47 119.67 80.2 135.37",
    style: {
      fill: "url(#linear-gradient-124)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.2 135.37 100.25 126.9 96.47 119.67 80.2 135.37",
    style: {
      fill: "url(#linear-gradient-125)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.88 129.16 78.02 117.07 96.47 119.67 74.88 129.16",
    style: {
      fill: "url(#linear-gradient-126)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.25 126.9 112.55 116.73 96.47 119.67 100.25 126.9",
    style: {
      fill: "url(#linear-gradient-127)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.02 117.07 88.46 97.87 96.47 119.67 78.02 117.07",
    style: {
      fill: "url(#linear-gradient-128)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.74 80.36 162.57 75.45 171.41 65 179.74 80.36",
    style: {
      fill: "url(#linear-gradient-129)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.57 75.45 155.53 44.78 171.41 65 162.57 75.45",
    style: {
      fill: "url(#linear-gradient-130)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.8 56.59 155.53 44.78 171.41 65 171.8 56.59",
    style: {
      fill: "url(#linear-gradient-131)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.17 20.78 183.14 12.93 157.71 8.47 151.17 20.78",
    style: {
      fill: "url(#linear-gradient-132)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.17 20.78 148.67 11.29 157.71 8.47 151.17 20.78",
    style: {
      fill: "url(#linear-gradient-133)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.94 170.61 169.3 164.06 157.58 167.45 169.94 170.61",
    style: {
      fill: "url(#linear-gradient-134)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.3 164.06 146.3 161.46 157.58 167.45 169.3 164.06",
    style: {
      fill: "url(#linear-gradient-135)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.5 162.76 146.3 161.46 157.58 167.45 141.5 162.76",
    style: {
      fill: "url(#linear-gradient-136)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.83 110.75 218.3 97.53 207.86 96.69 211.83 110.75",
    style: {
      fill: "url(#linear-gradient-137)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.13 98.66 204.02 88.33 207.86 96.69 198.13 98.66",
    style: {
      fill: "url(#linear-gradient-138)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.3 97.53 204.02 88.33 207.86 96.69 218.3 97.53",
    style: {
      fill: "url(#linear-gradient-139)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.5 162.76 146.3 161.46 143.42 158.3 141.5 162.76",
    style: {
      fill: "url(#linear-gradient-140)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.5 162.76 109.47 157.96 143.42 158.3 141.5 162.76",
    style: {
      fill: "url(#linear-gradient-141)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.3 161.46 146.82 137.23 143.42 158.3 146.3 161.46",
    style: {
      fill: "url(#linear-gradient-142)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.47 157.96 139.26 142.71 143.42 158.3 109.47 157.96",
    style: {
      fill: "url(#linear-gradient-143)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.26 142.71 146.82 137.23 143.42 158.3 139.26 142.71",
    style: {
      fill: "url(#linear-gradient-144)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.7 154.18 236.11 151.18 236.75 153.5 221.7 154.18",
    style: {
      fill: "url(#linear-gradient-145)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.15 170.44 240.53 139.32 236.75 153.5 258.15 170.44",
    style: {
      fill: "url(#linear-gradient-146)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.11 151.18 240.53 139.32 236.75 153.5 236.11 151.18",
    style: {
      fill: "url(#linear-gradient-147)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.46 97.87 111.27 73.98 105.31 98.1 88.46 97.87",
    style: {
      fill: "url(#linear-gradient-148)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.04 80.98 111.27 73.98 105.31 98.1 120.04 80.98",
    style: {
      fill: "url(#linear-gradient-149)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.47 119.67 88.46 97.87 105.31 98.1 96.47 119.67",
    style: {
      fill: "url(#linear-gradient-150)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.47 119.67 112.55 116.73 105.31 98.1 96.47 119.67",
    style: {
      fill: "url(#linear-gradient-151)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.47 157.96 100.83 149.26 126.7 129.84 109.47 157.96",
    style: {
      fill: "url(#linear-gradient-152)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.47 157.96 139.26 142.71 126.7 129.84 109.47 157.96",
    style: {
      fill: "url(#linear-gradient-153)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.83 149.26 96.02 138.03 126.7 129.84 100.83 149.26",
    style: {
      fill: "url(#linear-gradient-154)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.26 142.71 146.82 137.23 126.7 129.84 139.26 142.71",
    style: {
      fill: "url(#linear-gradient-155)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.02 138.03 100.25 126.9 126.7 129.84 96.02 138.03",
    style: {
      fill: "url(#linear-gradient-156)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.82 137.23 129.71 118.37 126.7 129.84 146.82 137.23",
    style: {
      fill: "url(#linear-gradient-157)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.25 126.9 125.17 125.77 126.7 129.84 100.25 126.9",
    style: {
      fill: "url(#linear-gradient-158)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.17 125.77 129.71 118.37 126.7 129.84 125.17 125.77",
    style: {
      fill: "url(#linear-gradient-159)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 64.04 1.02 63.37 12.62 22.02 0 64.04",
    style: {
      fill: "url(#linear-gradient-160)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1.02 63.37 25.11 46.42 12.62 22.02 1.02 63.37",
    style: {
      fill: "url(#linear-gradient-161)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.11 46.42 40.55 15.36 12.62 22.02 25.11 46.42",
    style: {
      fill: "url(#linear-gradient-162)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.55 15.36 21.78 4.52 12.62 22.02 40.55 15.36",
    style: {
      fill: "url(#linear-gradient-163)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.71 118.37 112.55 116.73 127.02 105.95 129.71 118.37",
    style: {
      fill: "url(#linear-gradient-164)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.16 106.17 127.02 105.95 147.46 113.97 153.16 106.17",
    style: {
      fill: "url(#linear-gradient-165)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.82 137.23 157.71 119.39 147.46 113.97 146.82 137.23",
    style: {
      fill: "url(#linear-gradient-166)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.82 137.23 129.71 118.37 147.46 113.97 146.82 137.23",
    style: {
      fill: "url(#linear-gradient-167)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.71 119.39 153.16 106.17 147.46 113.97 157.71 119.39",
    style: {
      fill: "url(#linear-gradient-168)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.71 118.37 127.02 105.95 147.46 113.97 129.71 118.37",
    style: {
      fill: "url(#linear-gradient-169)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.16 106.17 127.02 105.95 123.76 88.04 153.16 106.17",
    style: {
      fill: "url(#linear-gradient-170)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.51 63.08 25.11 46.42 27.03 49.25 5.51 63.08",
    style: {
      fill: "url(#linear-gradient-171)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.02 53.59 30.43 51.56 27.03 49.25 29.02 53.59",
    style: {
      fill: "url(#linear-gradient-172)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.43 51.56 25.11 46.42 27.03 49.25 30.43 51.56",
    style: {
      fill: "url(#linear-gradient-173)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.3 97.53 241.17 92.67 221.63 58.96 218.3 97.53",
    style: {
      fill: "url(#linear-gradient-174)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.3 97.53 204.02 88.33 221.63 58.96 218.3 97.53",
    style: {
      fill: "url(#linear-gradient-175)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.02 88.33 213.95 56.25 221.63 58.96 204.02 88.33",
    style: {
      fill: "url(#linear-gradient-176)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.95 56.25 236.62 52.63 221.63 58.96 213.95 56.25",
    style: {
      fill: "url(#linear-gradient-177)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.06 170.61 53.74 150.5 14.73 144.52 0.06 170.61",
    style: {
      fill: "url(#linear-gradient-178)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.06 170.61 3.14 125.94 14.73 144.52 0.06 170.61",
    style: {
      fill: "url(#linear-gradient-179)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.74 150.5 32.92 133 14.73 144.52 53.74 150.5",
    style: {
      fill: "url(#linear-gradient-180)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.43 23.61 101.66 18.24 94.42 11.35 97.43 23.61",
    style: {
      fill: "url(#linear-gradient-181)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.43 23.61 83.66 15.13 94.42 11.35 97.43 23.61",
    style: {
      fill: "url(#linear-gradient-182)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.66 15.13 75.39 6.1 94.42 11.35 83.66 15.13",
    style: {
      fill: "url(#linear-gradient-183)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.48 86.8 38.31 79.46 59.83 78.33 45.48 86.8",
    style: {
      fill: "url(#linear-gradient-184)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.85 113.8 70.91 112.16 54.19 91.72 60.85 113.8",
    style: {
      fill: "url(#linear-gradient-185)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.48 86.8 59.83 78.33 54.19 91.72 45.48 86.8",
    style: {
      fill: "url(#linear-gradient-186)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.31 119.11 60.85 113.8 54.19 91.72 38.31 119.11",
    style: {
      fill: "url(#linear-gradient-187)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.31 119.11 29.98 93.75 54.19 91.72 38.31 119.11",
    style: {
      fill: "url(#linear-gradient-188)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.16 106.17 123.76 88.04 133.81 73.36 153.16 106.17",
    style: {
      fill: "url(#linear-gradient-189)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.16 106.17 161.04 76.81 133.81 73.36 153.16 106.17",
    style: {
      fill: "url(#linear-gradient-190)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.76 88.04 120.04 80.98 133.81 73.36 123.76 88.04",
    style: {
      fill: "url(#linear-gradient-191)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.04 80.98 111.27 73.98 133.81 73.36 120.04 80.98",
    style: {
      fill: "url(#linear-gradient-192)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.04 76.81 162.57 75.45 133.81 73.36 161.04 76.81",
    style: {
      fill: "url(#linear-gradient-193)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.57 75.45 132.79 55.97 133.81 73.36 162.57 75.45",
    style: {
      fill: "url(#linear-gradient-194)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.27 73.98 132.79 55.97 133.81 73.36 111.27 73.98",
    style: {
      fill: "url(#linear-gradient-195)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.37 86.8 81.86 58.85 68.48 77.43 79.37 86.8",
    style: {
      fill: "url(#linear-gradient-196)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.83 78.33 63.42 53.2 68.48 77.43 59.83 78.33",
    style: {
      fill: "url(#linear-gradient-197)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.86 58.85 63.42 53.2 68.48 77.43 81.86 58.85",
    style: {
      fill: "url(#linear-gradient-198)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.31 79.46 59.83 78.33 45.48 54.44 38.31 79.46",
    style: {
      fill: "url(#linear-gradient-199)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.31 79.46 29.15 57.77 45.48 54.44 38.31 79.46",
    style: {
      fill: "url(#linear-gradient-200)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.83 78.33 63.42 53.2 45.48 54.44 59.83 78.33",
    style: {
      fill: "url(#linear-gradient-201)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.15 57.77 30.43 51.56 45.48 54.44 29.15 57.77",
    style: {
      fill: "url(#linear-gradient-202)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.48 54.44 63.42 53.2 66.17 40.21 45.48 54.44",
    style: {
      fill: "url(#linear-gradient-203)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.42 53.2 83.21 51.45 66.17 40.21 63.42 53.2",
    style: {
      fill: "url(#linear-gradient-204)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.21 51.45 97.43 23.61 66.17 40.21 83.21 51.45",
    style: {
      fill: "url(#linear-gradient-205)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.43 23.61 83.66 15.13 66.17 40.21 97.43 23.61",
    style: {
      fill: "url(#linear-gradient-206)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.79 22.42 63.86 20.44 66.17 40.21 60.79 22.42",
    style: {
      fill: "url(#linear-gradient-207)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.86 20.44 83.66 15.13 66.17 40.21 63.86 20.44",
    style: {
      fill: "url(#linear-gradient-208)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.68 17.51 257.12 0 244.37 8.92 241.68 17.51",
    style: {
      fill: "url(#linear-gradient-209)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.54 0.4 257.12 0 244.37 8.92 220.54 0.4",
    style: {
      fill: "url(#linear-gradient-210)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.38 25.98 183.14 12.93 208.57 9.04 211.38 25.98",
    style: {
      fill: "url(#linear-gradient-211)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.94 170.61 221.7 154.18 228.42 160.67 169.94 170.61",
    style: {
      fill: "url(#linear-gradient-212)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.7 154.18 236.75 153.5 228.42 160.67 221.7 154.18",
    style: {
      fill: "url(#linear-gradient-213)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.51 137.46 224.84 136.61 212.09 134.18 211.51 137.46",
    style: {
      fill: "url(#linear-gradient-214)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.51 137.46 210.04 130.63 212.09 134.18 211.51 137.46",
    style: {
      fill: "url(#linear-gradient-215)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.84 136.61 216.89 128.59 212.09 134.18 224.84 136.61",
    style: {
      fill: "url(#linear-gradient-216)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.04 130.63 216.89 128.59 212.09 134.18 210.04 130.63",
    style: {
      fill: "url(#linear-gradient-217)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.53 92.05 183.65 90.64 190.44 80.48 186.53 92.05",
    style: {
      fill: "url(#linear-gradient-218)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.53 92.05 204.02 88.33 190.44 80.48 186.53 92.05",
    style: {
      fill: "url(#linear-gradient-219)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.65 90.64 180.57 86.07 190.44 80.48 183.65 90.64",
    style: {
      fill: "url(#linear-gradient-220)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.02 88.33 213.95 56.25 190.44 80.48 204.02 88.33",
    style: {
      fill: "url(#linear-gradient-221)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.57 86.07 179.74 80.36 190.44 80.48 180.57 86.07",
    style: {
      fill: "url(#linear-gradient-222)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.74 80.36 171.41 65 190.44 80.48 179.74 80.36",
    style: {
      fill: "url(#linear-gradient-223)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.73 144.52 32.92 133 27.22 127.52 14.73 144.52",
    style: {
      fill: "url(#linear-gradient-224)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.73 144.52 3.14 125.94 27.22 127.52 14.73 144.52",
    style: {
      fill: "url(#linear-gradient-225)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.92 133 38.31 119.11 27.22 127.52 32.92 133",
    style: {
      fill: "url(#linear-gradient-226)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.14 125.94 3.27 119.44 27.22 127.52 3.14 125.94",
    style: {
      fill: "url(#linear-gradient-227)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.27 119.44 31.2 116.79 27.22 127.52 3.27 119.44",
    style: {
      fill: "url(#linear-gradient-228)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.31 119.11 31.2 116.79 27.22 127.52 38.31 119.11",
    style: {
      fill: "url(#linear-gradient-229)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.06 170.61 53.74 150.5 101.4 170.16 0.06 170.61",
    style: {
      fill: "url(#linear-gradient-230)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.94 170.61 157.58 167.45 101.4 170.16 169.94 170.61",
    style: {
      fill: "url(#linear-gradient-231)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.28 154.4 87.69 153.16 101.4 170.16 96.28 154.4",
    style: {
      fill: "url(#linear-gradient-232)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.69 153.16 53.74 150.5 101.4 170.16 87.69 153.16",
    style: {
      fill: "url(#linear-gradient-233)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.83 167.62 141.5 162.76 101.4 170.16 103.83 167.62",
    style: {
      fill: "url(#linear-gradient-234)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.83 167.62 96.28 154.4 101.4 170.16 103.83 167.62",
    style: {
      fill: "url(#linear-gradient-235)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.58 167.45 141.5 162.76 101.4 170.16 157.58 167.45",
    style: {
      fill: "url(#linear-gradient-236)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.45 69.3 29.15 57.77 21.27 65.74 23.45 69.3",
    style: {
      fill: "url(#linear-gradient-237)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.51 63.08 27.03 49.25 21.27 65.74 5.51 63.08",
    style: {
      fill: "url(#linear-gradient-238)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.15 57.77 29.02 53.59 21.27 65.74 29.15 57.77",
    style: {
      fill: "url(#linear-gradient-239)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.02 53.59 27.03 49.25 21.27 65.74 29.02 53.59",
    style: {
      fill: "url(#linear-gradient-240)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.62 52.63 208.05 39.93 219.01 30.44 236.62 52.63",
    style: {
      fill: "url(#linear-gradient-241)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.62 52.63 241.68 17.51 219.01 30.44 236.62 52.63",
    style: {
      fill: "url(#linear-gradient-242)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.05 39.93 211.38 25.98 219.01 30.44 208.05 39.93",
    style: {
      fill: "url(#linear-gradient-243)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.48 54.44 30.43 51.56 56.37 29.88 45.48 54.44",
    style: {
      fill: "url(#linear-gradient-244)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.48 54.44 66.17 40.21 56.37 29.88 45.48 54.44",
    style: {
      fill: "url(#linear-gradient-245)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.43 51.56 25.11 46.42 56.37 29.88 30.43 51.56",
    style: {
      fill: "url(#linear-gradient-246)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.11 46.42 40.55 15.36 56.37 29.88 25.11 46.42",
    style: {
      fill: "url(#linear-gradient-247)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.17 40.21 60.79 22.42 56.37 29.88 66.17 40.21",
    style: {
      fill: "url(#linear-gradient-248)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.79 22.42 40.55 15.36 56.37 29.88 60.79 22.42",
    style: {
      fill: "url(#linear-gradient-249)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.06 94.2 29.98 93.75 12.17 81.66 0.06 94.2",
    style: {
      fill: "url(#linear-gradient-250)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.06 94.2 0 64.04 12.17 81.66 0.06 94.2",
    style: {
      fill: "url(#linear-gradient-251)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.98 93.75 24.79 78.56 12.17 81.66 29.98 93.75",
    style: {
      fill: "url(#linear-gradient-252)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.79 78.56 23.45 69.3 12.17 81.66 24.79 78.56",
    style: {
      fill: "url(#linear-gradient-253)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.45 69.3 21.27 65.74 12.17 81.66 23.45 69.3",
    style: {
      fill: "url(#linear-gradient-254)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.27 65.74 5.51 63.08 12.17 81.66 21.27 65.74",
    style: {
      fill: "url(#linear-gradient-255)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 64.04 5.51 63.08 12.17 81.66 0 64.04",
    style: {
      fill: "url(#linear-gradient-256)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.3 164.06 195.05 142.88 180.77 136.56 169.3 164.06",
    style: {
      fill: "url(#linear-gradient-257)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.3 164.06 146.82 137.23 180.77 136.56 169.3 164.06",
    style: {
      fill: "url(#linear-gradient-258)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.05 142.88 191.4 128.42 180.77 136.56 195.05 142.88",
    style: {
      fill: "url(#linear-gradient-259)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.82 137.23 157.71 119.39 180.77 136.56 146.82 137.23",
    style: {
      fill: "url(#linear-gradient-260)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.4 128.42 168.85 113.8 180.77 136.56 191.4 128.42",
    style: {
      fill: "url(#linear-gradient-261)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.71 119.39 168.85 113.8 180.77 136.56 157.71 119.39",
    style: {
      fill: "url(#linear-gradient-262)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.21 108.26 243.54 101.77 248.15 88.83 258.21 108.26",
    style: {
      fill: "url(#linear-gradient-263)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.21 108.26 258.15 63.99 248.15 88.83 258.21 108.26",
    style: {
      fill: "url(#linear-gradient-264)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.54 101.77 241.17 92.67 248.15 88.83 243.54 101.77",
    style: {
      fill: "url(#linear-gradient-265)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.17 92.67 221.63 58.96 248.15 88.83 241.17 92.67",
    style: {
      fill: "url(#linear-gradient-266)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.15 63.99 236.62 52.63 248.15 88.83 258.15 63.99",
    style: {
      fill: "url(#linear-gradient-267)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.63 58.96 236.62 52.63 248.15 88.83 221.63 58.96",
    style: {
      fill: "url(#linear-gradient-268)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.7 154.18 236.11 151.18 223.75 145.14 221.7 154.18",
    style: {
      fill: "url(#linear-gradient-269)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.7 154.18 211.51 137.46 223.75 145.14 221.7 154.18",
    style: {
      fill: "url(#linear-gradient-270)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.11 151.18 240.53 139.32 223.75 145.14 236.11 151.18",
    style: {
      fill: "url(#linear-gradient-271)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.53 139.32 224.84 136.61 223.75 145.14 240.53 139.32",
    style: {
      fill: "url(#linear-gradient-272)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.51 137.46 224.84 136.61 223.75 145.14 211.51 137.46",
    style: {
      fill: "url(#linear-gradient-273)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.01 30.44 211.38 25.98 225.6 5.93 219.01 30.44",
    style: {
      fill: "url(#linear-gradient-274)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.01 30.44 241.68 17.51 225.6 5.93 219.01 30.44",
    style: {
      fill: "url(#linear-gradient-275)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.38 25.98 208.57 9.04 225.6 5.93 211.38 25.98",
    style: {
      fill: "url(#linear-gradient-276)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.68 17.51 244.37 8.92 225.6 5.93 241.68 17.51",
    style: {
      fill: "url(#linear-gradient-277)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.57 9.04 220.54 0.4 225.6 5.93 208.57 9.04",
    style: {
      fill: "url(#linear-gradient-278)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.37 8.92 220.54 0.4 225.6 5.93 244.37 8.92",
    style: {
      fill: "url(#linear-gradient-279)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.14 12.93 208.57 9.04 187.04 3.05 183.14 12.93",
    style: {
      fill: "url(#linear-gradient-280)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.14 12.93 157.71 8.47 187.04 3.05 183.14 12.93",
    style: {
      fill: "url(#linear-gradient-281)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.57 9.04 220.54 0.4 187.04 3.05 208.57 9.04",
    style: {
      fill: "url(#linear-gradient-282)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.49 0.9 220.54 0.4 187.04 3.05 43.49 0.9",
    style: {
      fill: "url(#linear-gradient-283)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.79 55.97 155.53 44.78 128.43 36.48 132.79 55.97",
    style: {
      fill: "url(#linear-gradient-284)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.79 55.97 115.69 39.08 128.43 36.48 132.79 55.97",
    style: {
      fill: "url(#linear-gradient-285)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.53 44.78 151.17 20.78 128.43 36.48 155.53 44.78",
    style: {
      fill: "url(#linear-gradient-286)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.69 39.08 122.67 23.21 128.43 36.48 115.69 39.08",
    style: {
      fill: "url(#linear-gradient-287)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.67 23.21 151.17 20.78 128.43 36.48 122.67 23.21",
    style: {
      fill: "url(#linear-gradient-288)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.66 18.24 127.15 15.25 104.73 5.99 101.66 18.24",
    style: {
      fill: "url(#linear-gradient-289)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.66 18.24 94.42 11.35 104.73 5.99 101.66 18.24",
    style: {
      fill: "url(#linear-gradient-290)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.15 15.25 148.67 11.29 104.73 5.99 127.15 15.25",
    style: {
      fill: "url(#linear-gradient-291)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.42 11.35 75.39 6.1 104.73 5.99 94.42 11.35",
    style: {
      fill: "url(#linear-gradient-292)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.67 11.29 157.71 8.47 104.73 5.99 148.67 11.29",
    style: {
      fill: "url(#linear-gradient-293)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.71 8.47 187.04 3.05 104.73 5.99 157.71 8.47",
    style: {
      fill: "url(#linear-gradient-294)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.39 6.1 49.32 2.09 104.73 5.99 75.39 6.1",
    style: {
      fill: "url(#linear-gradient-295)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.04 3.05 43.49 0.9 104.73 5.99 187.04 3.05",
    style: {
      fill: "url(#linear-gradient-296)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.32 2.09 43.49 0.9 104.73 5.99 49.32 2.09",
    style: {
      fill: "url(#linear-gradient-297)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.93 113.34 243.54 101.77 242.45 102.78 251.93 113.34",
    style: {
      fill: "url(#linear-gradient-298)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.54 101.77 241.17 92.67 242.45 102.78 243.54 101.77",
    style: {
      fill: "url(#linear-gradient-299)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.3 97.53 241.17 92.67 242.45 102.78 218.3 97.53",
    style: {
      fill: "url(#linear-gradient-300)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.39 114.81 251.93 113.34 242.45 102.78 237.39 114.81",
    style: {
      fill: "url(#linear-gradient-301)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.39 114.81 218.3 97.53 242.45 102.78 237.39 114.81",
    style: {
      fill: "url(#linear-gradient-302)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.74 150.5 69.18 141.53 47.79 124.58 53.74 150.5",
    style: {
      fill: "url(#linear-gradient-303)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.74 150.5 32.92 133 47.79 124.58 53.74 150.5",
    style: {
      fill: "url(#linear-gradient-304)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.18 141.53 74.88 129.16 47.79 124.58 69.18 141.53",
    style: {
      fill: "url(#linear-gradient-305)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.92 133 38.31 119.11 47.79 124.58 32.92 133",
    style: {
      fill: "url(#linear-gradient-306)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.88 129.16 60.85 113.8 47.79 124.58 74.88 129.16",
    style: {
      fill: "url(#linear-gradient-307)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.31 119.11 60.85 113.8 47.79 124.58 38.31 119.11",
    style: {
      fill: "url(#linear-gradient-308)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.42 96.97 175.77 82.62 163.98 79.12 166.42 96.97",
    style: {
      fill: "url(#linear-gradient-309)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.42 96.97 161.04 76.81 163.98 79.12 166.42 96.97",
    style: {
      fill: "url(#linear-gradient-310)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.77 82.62 162.57 75.45 163.98 79.12 175.77 82.62",
    style: {
      fill: "url(#linear-gradient-311)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.04 76.81 162.57 75.45 163.98 79.12 161.04 76.81",
    style: {
      fill: "url(#linear-gradient-312)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.98 93.75 54.19 91.72 39.14 87.7 29.98 93.75",
    style: {
      fill: "url(#linear-gradient-313)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.98 93.75 24.79 78.56 39.14 87.7 29.98 93.75",
    style: {
      fill: "url(#linear-gradient-314)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.19 91.72 45.48 86.8 39.14 87.7 54.19 91.72",
    style: {
      fill: "url(#linear-gradient-315)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.48 86.8 38.31 79.46 39.14 87.7 45.48 86.8",
    style: {
      fill: "url(#linear-gradient-316)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.31 79.46 24.79 78.56 39.14 87.7 38.31 79.46",
    style: {
      fill: "url(#linear-gradient-317)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.44 80.48 171.41 65 193.58 56.93 190.44 80.48",
    style: {
      fill: "url(#linear-gradient-318)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.44 80.48 213.95 56.25 193.58 56.93 190.44 80.48",
    style: {
      fill: "url(#linear-gradient-319)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.41 65 171.8 56.59 193.58 56.93 171.41 65",
    style: {
      fill: "url(#linear-gradient-320)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.8 56.59 177.63 51.22 193.58 56.93 171.8 56.59",
    style: {
      fill: "url(#linear-gradient-321)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.95 56.25 198.45 44.95 193.58 56.93 213.95 56.25",
    style: {
      fill: "url(#linear-gradient-322)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.63 51.22 195.63 44.62 193.58 56.93 177.63 51.22",
    style: {
      fill: "url(#linear-gradient-323)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.45 44.95 195.63 44.62 193.58 56.93 198.45 44.95",
    style: {
      fill: "url(#linear-gradient-324)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.91 112.16 88.46 97.87 75.39 93.58 70.91 112.16",
    style: {
      fill: "url(#linear-gradient-325)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.91 112.16 54.19 91.72 75.39 93.58 70.91 112.16",
    style: {
      fill: "url(#linear-gradient-326)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.46 97.87 79.37 86.8 75.39 93.58 88.46 97.87",
    style: {
      fill: "url(#linear-gradient-327)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.19 91.72 59.83 78.33 75.39 93.58 54.19 91.72",
    style: {
      fill: "url(#linear-gradient-328)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.37 86.8 68.48 77.43 75.39 93.58 79.37 86.8",
    style: {
      fill: "url(#linear-gradient-329)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.83 78.33 68.48 77.43 75.39 93.58 59.83 78.33",
    style: {
      fill: "url(#linear-gradient-330)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.94 170.61 228.42 160.67 243.16 168.52 169.94 170.61",
    style: {
      fill: "url(#linear-gradient-331)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.94 170.61 258.15 170.44 243.16 168.52 169.94 170.61",
    style: {
      fill: "url(#linear-gradient-332)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.42 160.67 236.75 153.5 243.16 168.52 228.42 160.67",
    style: {
      fill: "url(#linear-gradient-333)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.15 170.44 236.75 153.5 243.16 168.52 258.15 170.44",
    style: {
      fill: "url(#linear-gradient-334)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.83 110.75 199.28 109.79 202.8 101.32 211.83 110.75",
    style: {
      fill: "url(#linear-gradient-335)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.83 110.75 207.86 96.69 202.8 101.32 211.83 110.75",
    style: {
      fill: "url(#linear-gradient-336)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.28 109.79 198.13 98.66 202.8 101.32 199.28 109.79",
    style: {
      fill: "url(#linear-gradient-337)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.13 98.66 207.86 96.69 202.8 101.32 198.13 98.66",
    style: {
      fill: "url(#linear-gradient-338)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.02 105.95 123.76 88.04 118.38 96.12 127.02 105.95",
    style: {
      fill: "url(#linear-gradient-339)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.31 98.1 120.04 80.98 118.38 96.12 105.31 98.1",
    style: {
      fill: "url(#linear-gradient-340)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.76 88.04 120.04 80.98 118.38 96.12 123.76 88.04",
    style: {
      fill: "url(#linear-gradient-341)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.55 116.73 127.02 105.95 118.38 96.12 112.55 116.73",
    style: {
      fill: "url(#linear-gradient-342)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.55 116.73 105.31 98.1 118.38 96.12 112.55 116.73",
    style: {
      fill: "url(#linear-gradient-343)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.53,90.19a13.61,13.61,0,0,0-6.34-3.36,15.46,15.46,0,0,0,1.54-1.24,14,14,0,0,0,4.57-10.28c0-.41,0-.84-.06-1.26a14.25,14.25,0,0,0-14.54-13.5c-.47,0-.93,0-1.4.06a25.23,25.23,0,0,0-6-11.93,28.55,28.55,0,0,0-12.78-8.44,40.89,40.89,0,0,0-12.89-1.88,1.29,1.29,0,0,0-.93.39,1.32,1.32,0,0,0-.38.92V164.49a1.31,1.31,0,0,0,.4.95,1.29,1.29,0,0,0,1,.36c6.44-.3,13-.89,19.57-3a1.3,1.3,0,0,0,.9-1.19h0c0-.09.37-8.37,7.82-19.45a19.4,19.4,0,0,0,1.84-2.92,15.14,15.14,0,0,0,1.9-6.88,9.43,9.43,0,0,0-.89-4.07l-.06-.12a12.14,12.14,0,0,0,1.59.11,15.58,15.58,0,0,0,10.27-4,14.6,14.6,0,0,0,3.38-4.48,12.8,12.8,0,0,0,1.3-5.63,13.41,13.41,0,0,0-.28-2.71,13.06,13.06,0,0,0-.42-1.48,12.61,12.61,0,0,0,3.52-4.29,13.49,13.49,0,0,0,1.44-6.07A12.64,12.64,0,0,0,118.53,90.19Zm.25,14.24a10.27,10.27,0,0,1-2.3,3,14.25,14.25,0,0,0-2.69-3.3,13.63,13.63,0,0,0-7.61-3.52,1.31,1.31,0,0,0-.29,2.61,11.33,11.33,0,0,1,9.56,8.7,10.29,10.29,0,0,1-.81,6.67c-.16.33-.35.66-.54,1h-.36a9.44,9.44,0,0,1-3.33-.72,14.62,14.62,0,0,1-5.84-4.36,26.35,26.35,0,0,1-1.85-2.6c-.41-.61-.84-1.24-1.33-1.86v-7.7a3.67,3.67,0,1,0-2.62,0v5.16a17,17,0,0,0-3.38-2,21.55,21.55,0,0,0-8.69-1.77A23.85,23.85,0,0,0,83,104a1.31,1.31,0,0,0,.41,2.59,21.13,21.13,0,0,1,3.28-.26,18.78,18.78,0,0,1,7.62,1.55,13.52,13.52,0,0,1,4.33,3,17.24,17.24,0,0,1,1.88,2.49,29.88,29.88,0,0,0,2,2.85,17.3,17.3,0,0,0,6.93,5.12,15.28,15.28,0,0,0,2.59.72,13.06,13.06,0,0,1-8.74,3.58,10.8,10.8,0,0,1-4.54-1l-.11-.09a1.14,1.14,0,0,0-.54-.24,11.65,11.65,0,0,1-1.54-1,11.24,11.24,0,0,1-4-8.78,12.42,12.42,0,0,1,.44-3.3,1.3,1.3,0,0,0-.91-1.61,1.31,1.31,0,0,0-1.61.91h0a15.18,15.18,0,0,0-.54,4,14.13,14.13,0,0,0,1.66,6.74H83.4a3.68,3.68,0,1,0,0,2.62H93.46A13,13,0,0,0,95,125.26a13.19,13.19,0,0,0,2.41,1.56,7.31,7.31,0,0,1,2.07,2.56,6.64,6.64,0,0,1,.64,2.94,12.65,12.65,0,0,1-1.6,5.66,21.18,21.18,0,0,1-1.12,1.88c-.15.22-.28.39-.37.51l-.09.12,0,0h0l-.06.09a59.31,59.31,0,0,0-3.55,6h-.1a7.66,7.66,0,0,1-4.33-1.14,6.59,6.59,0,0,1-1.84-1.8,9.5,9.5,0,0,1-1.32-3c0-.12-.05-.24-.08-.35a3.65,3.65,0,1,0-4.06-.76,3.55,3.55,0,0,0,1.42.86,12.32,12.32,0,0,0,1.32,3.85,9.33,9.33,0,0,0,3.13,3.43A10,10,0,0,0,92,149.15a39.92,39.92,0,0,0-3.42,11.37,69.05,69.05,0,0,1-16.68,2.59V87.47c.21.32.43.64.67,1a17.09,17.09,0,0,0,4.5,4.32,12.82,12.82,0,0,0,5.81,2,3.67,3.67,0,1,0,0-2.64,10.05,10.05,0,0,1-4.45-1.55,16,16,0,0,1-5.08-5.65,23.62,23.62,0,0,1-1.19-2.45c-.13-.31-.22-.56-.28-.73l0-.06V41a37.36,37.36,0,0,1,10.76,1.73A25.87,25.87,0,0,1,94.31,50.4c4.35,5,5.72,10,5.73,14a15.18,15.18,0,0,1-.57,4.2,8.3,8.3,0,0,1-1.25,2.65,1.31,1.31,0,0,0,2.07,1.61A10.59,10.59,0,0,0,102,69.35a17.5,17.5,0,0,0,.68-4.94c0-.39,0-.79,0-1.19.36,0,.72,0,1.08,0a11.92,11.92,0,0,1,8,2.93,12.06,12.06,0,0,1,3.9,8.18c0,.35.05.69.05,1A11.33,11.33,0,0,1,112,83.67a12.68,12.68,0,0,1-8.52,3.38,12.18,12.18,0,0,1-8.76-3.81A3.67,3.67,0,1,0,92,84.36h.14a1.48,1.48,0,0,0,.19.27,15.23,15.23,0,0,0,8.42,4.79,14.63,14.63,0,0,0-1.4,1.21,1.31,1.31,0,1,0,1.85,1.86,11.36,11.36,0,0,1,8-3.39,11,11,0,0,1,7.51,3,10,10,0,0,1,3.19,7.43A10.93,10.93,0,0,1,118.78,104.43Zm-17.65-5.51a1,1,0,1,1-1-1A1,1,0,0,1,101.13,98.92ZM81,122.5a1,1,0,1,1-1-1A1,1,0,0,1,81,122.5Zm4.16,14.4a1.06,1.06,0,0,1-1,1,1,1,0,0,1-.74-.31,1,1,0,0,1,0-1.48,1,1,0,0,1,.74-.31,1.06,1.06,0,0,1,1,1.05Zm.12-43.44a1,1,0,1,1,1,1.05A1,1,0,0,1,85.31,93.46Zm7.78-12.77a1.06,1.06,0,1,1-1-1A1.06,1.06,0,0,1,93.09,80.69Z",
    transform: "translate(171.23 0.98)",
    style: {
      fill: "#0074b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.23,198.49a10.41,10.41,0,0,0,18.24,0A51.75,51.75,0,0,1,58.23,198.49Z",
    transform: "translate(171.23 0.98)",
    style: {
      fill: "#0074b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,165.21a96.64,96.64,0,0,1-43.85,0,.52.52,0,0,0-.67.52v7.41a.91.91,0,0,0,.67.84A96.92,96.92,0,0,0,89,174a.91.91,0,0,0,.67-.84v-7.41A.52.52,0,0,0,89,165.21Zm-41.81,7.11h-.65v-4.69h.65Zm3.08.61h-.65v-4.69h.65Zm3.1.51h-.66v-4.7h.66Zm3.11.4h-.66v-4.69h.66Zm3.11.3h-.65v-4.69h.65Zm3.12.2h-.65v-4.69h.65Zm3.13.11h-.66v-4.7h.66Zm3.13,0h-.66v-4.7H69Zm3.12-.11h-.65v-4.69h.65Zm3.12-.2h-.65v-4.69h.65Zm3.12-.3h-.66v-4.69h.66Zm3.11-.4h-.66v-4.7h.66Zm3.09-.51h-.65v-4.69h.65Zm3.08-.61H87v-4.69h.65Z",
    transform: "translate(171.23 0.98)",
    style: {
      fill: "#0074b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.59,176.05a86.32,86.32,0,0,1-39,0,.52.52,0,0,0-.67.52V184a.91.91,0,0,0,.67.84,86.6,86.6,0,0,0,39,0,.91.91,0,0,0,.67-.84v-7.41A.52.52,0,0,0,86.59,176.05Zm-36.3,7.25h-.65v-4.69h.65Zm3.09.57h-.66v-4.7h.66Zm3.1.45h-.65v-4.69h.65Zm3.11.34h-.65V180h.65Zm3.12.23h-.65v-4.7h.65Zm3.13.11h-.66v-4.69h.66ZM69,185h-.66v-4.69H69Zm3.12-.11h-.65v-4.7h.65Zm3.12-.23h-.65V180h.65Zm3.11-.34h-.65v-4.69h.65Zm3.11-.45h-.66v-4.7h.66Zm3.09-.57h-.66v-4.69h.66Z",
    transform: "translate(171.23 0.98)",
    style: {
      fill: "#0074b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.48,186.89a73,73,0,0,1-32.81,0,.52.52,0,0,0-.67.52v7.41a.9.9,0,0,0,.67.84,73,73,0,0,0,32.81,0,.9.9,0,0,0,.67-.84v-7.41A.52.52,0,0,0,83.48,186.89ZM53.4,194.13h-.66v-4.69h.66Zm3.09.54h-.66V190h.66Zm3.11.4h-.66v-4.69h.66Zm3.12.27h-.66v-4.7h.66Zm3.12.13h-.66v-4.69h.66Zm3.13,0h-.66v-4.69H69Zm3.12-.13h-.65v-4.7h.65Zm3.12-.27h-.66v-4.69h.66Zm3.11-.4h-.66V190h.66Zm3.09-.54h-.66v-4.69h.66Z",
    transform: "translate(171.23 0.98)",
    style: {
      fill: "#0074b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.23,165.8a1.27,1.27,0,0,0,1-.36,1.32,1.32,0,0,0,.41-.95V39.77a1.34,1.34,0,0,0-.41-1,1.29,1.29,0,0,0-1-.35,53.8,53.8,0,0,0-6.89.83h0a55.44,55.44,0,0,0-28.52,94.27l.06.08A53.47,53.47,0,0,1,41.5,152.82a43.33,43.33,0,0,1,1.88,6.42c.15.78.25,1.38.3,1.79q0,.3.06.45v.13h0a1.31,1.31,0,0,0,.9,1.14C51.24,164.91,57.78,165.5,64.23,165.8Z",
    transform: "translate(171.23 0.98)",
    style: {
      mixBlendMode: "hue",
      fill: "url(#linear-gradient-344)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.17,158.82l-1.7,2.13,0,1.32a21.72,21.72,0,0,0-1,2.5,29.48,29.48,0,0,0-.83,3,18.32,18.32,0,0,0-.47,3.75,28.14,28.14,0,0,0,.17,3.9,32.94,32.94,0,0,0,.63,3.77,29.23,29.23,0,0,0,1,3.35,2.23,2.23,0,0,0-.26.73c-.08.36-.14.75-.19,1.16s-.07.79-.09,1.15a2,2,0,0,0,.07.78l.33.52a.42.42,0,0,1,.24.33c0,.16.06.3.09.43a3.56,3.56,0,0,1-.61,2.26,8.2,8.2,0,0,1-1.77-.45q-.83-.3-1.53-.63a8.35,8.35,0,0,0-1.11-1.84l-1.16-1.37c-.35-.38-.68-.77-1-1.18a11.12,11.12,0,0,1-1-1.56,27.34,27.34,0,0,0-.47-2.83q-.28-1.27-.66-2.64l-.14-.52c.06-1.17.12-2.35.19-3.56a27.24,27.24,0,0,0,0-3.14,4.17,4.17,0,0,0,.11-.83c0-.3,0-.6.07-.92v-.56a2.58,2.58,0,0,1,0-.57l1-.09-.33-1.51.52-.57.19-.85a19.51,19.51,0,0,1,.75-4.7,18.71,18.71,0,0,1,1.75-3.94l.38-.7c.53-.73,1.07-1.5,1.6-2.31s1.15-1.7,1.84-2.65c1.1-1.19,2.07-2.22,2.9-3.06a14.12,14.12,0,0,1,2.53-2.08l.42-.52c.6-.57,1.11-1,1.53-1.39s.81-.72,1.16-1.06l.94-.85a5.52,5.52,0,0,1,.85-.62,1.73,1.73,0,0,0,1.28.38,5.21,5.21,0,0,0,1-.23,1.66,1.66,0,0,1,.56,1,5.37,5.37,0,0,1-.18,1.18c-.1.41-.18.88-.26,1.42a3.24,3.24,0,0,0,.26,1.74,7.3,7.3,0,0,0-.4,1.07q-.16.54-.36,1.11a5.41,5.41,0,0,1-.33.82,1.83,1.83,0,0,1-.31.43,4.1,4.1,0,0,1-.37.33,3,3,0,0,0-.5.54,8.13,8.13,0,0,0-2.19,1.34,19,19,0,0,0-2.08,2,18.07,18.07,0,0,0-1.7,2.29,10.46,10.46,0,0,0-1.06,2.17Z",
    transform: "translate(171.23 0.98)",
    style: {
      fill: "#34b3f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.85,181.85a12.17,12.17,0,0,1-1.46-.14,7.27,7.27,0,0,1-1.35-2.2,14.46,14.46,0,0,1-.89-3,15.36,15.36,0,0,1-.29-3.16,7.48,7.48,0,0,1,.55-2.81s.14-.41.44-1.13l1.16-2.76c.47-1.12,1-2.36,1.6-3.73s1.2-2.71,1.8-4,1.17-2.53,1.72-3.61a23,23,0,0,1,1.44-2.53c.28-.44.54-.86.78-1.27s.46-.79.68-1.13l1-1.58a8.42,8.42,0,0,1,1-1.32,6.59,6.59,0,0,1,1.2-1,6.9,6.9,0,0,1,1.61-.78,8.31,8.31,0,0,1,1,.49,3.53,3.53,0,0,1,.75.64l.14.66a.74.74,0,0,0,.31.45.76.76,0,0,0,.36.12,8.68,8.68,0,0,1,1.06.3,3.36,3.36,0,0,0,1,.22c.13.19.25.37.36.56a4.28,4.28,0,0,0,.35.52,20.37,20.37,0,0,1,1.56,2.64,3.31,3.31,0,0,1,0,2.79l.05.52a1.11,1.11,0,0,1,.23.61,4.94,4.94,0,0,1-.09.8c0,.26-.06.53-.07.83a3.08,3.08,0,0,0,.11,1l.34.37a3.15,3.15,0,0,0,1.46.38,3.46,3.46,0,0,0,1.7-.42c.5-.29,1-.57,1.41-.85a9,9,0,0,1,1-.62,4.27,4.27,0,0,1,.87-.33c.66-.63,1.27-1.18,1.82-1.67s1.12-1,1.72-1.49a43,43,0,0,0,3.3-3,11.28,11.28,0,0,0,2.55-3.94,2.16,2.16,0,0,1,1.18-.33,3.65,3.65,0,0,1,1.32.26c.44.18.88.37,1.32.59a1.37,1.37,0,0,0,.26.14,1.43,1.43,0,0,1,.26.15,1.32,1.32,0,0,0,.43.94c.16.12.26.2.33.24l.19.09.63.42a1.25,1.25,0,0,1,.41.52,3.81,3.81,0,0,0,1.41,2,2.19,2.19,0,0,0,.05,1,8.52,8.52,0,0,0,.33,1,2,2,0,0,1,.14.35c0,.11.08.24.14.4l-1-.09.14,1a4.13,4.13,0,0,1-.11,1.79,6.74,6.74,0,0,1-.59,1.56c.06.94.09,1.69.09,2.24a12.12,12.12,0,0,1-.09,1.53,8.3,8.3,0,0,1-.31,1.35,12.52,12.52,0,0,1-.54,1.34,17.38,17.38,0,0,1-.83,6.56q-1,3-2.19,5.57l-.28.61a3.46,3.46,0,0,0-.24.57,5.43,5.43,0,0,0-.94.33,5.16,5.16,0,0,0-.81.42,6.37,6.37,0,0,1-1,.54,2.72,2.72,0,0,1-1.09.22c-1.51-1.1-2.29-3-2.34-5.71a37.09,37.09,0,0,1,1.73-10.34.7.7,0,0,0,.28-.7v-.52l-.47-.05a1.88,1.88,0,0,0-.43.05c-.12,0-.22.17-.28.42-1,.72-2.1,1.47-3.28,2.24a41.55,41.55,0,0,1-3.66,2.13,27.61,27.61,0,0,1-3.84,1.6,12.41,12.41,0,0,1-3.8.64c-3.15,0-5.52-1.61-7.13-4.82l-.42-.85-.47.76c-.1.16-.26.46-.5.92s-.47,1-.71,1.58a18.88,18.88,0,0,0-.61,1.84,4.11,4.11,0,0,0-.16,1.65,11.48,11.48,0,0,0-1.11,1.18,4.18,4.18,0,0,0-.78,1.51.8.8,0,0,0,0,.45,3.26,3.26,0,0,0,.14.45.76.76,0,0,1-.19.47,2.41,2.41,0,0,1-.33.28l-.47.5a1.74,1.74,0,0,0-.56,1.18c0,.2-.07.38-.1.54a1.3,1.3,0,0,1-.14.71c-.31.66-.59,1.2-.83,1.63a4.26,4.26,0,0,1-.68,1,1.83,1.83,0,0,1-.68.45A2.64,2.64,0,0,1,129.85,181.85Z",
    transform: "translate(171.23 0.98)",
    style: {
      fill: "#004aae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.75,168.83a2.71,2.71,0,0,0-.57.68c-.16.27-.31.54-.47.83s-.33.67-.52,1a3.82,3.82,0,0,1-.71.85,6.14,6.14,0,0,1-.47,1.11,5.26,5.26,0,0,1-.76.92,11.33,11.33,0,0,1-2.21,4.1,2.36,2.36,0,0,1-.26.83q-.21.39-.45.78c-.06.09-.13.19-.19.3l-.14.26-.1.47a3.2,3.2,0,0,1-.51.66l-.52.52a3.93,3.93,0,0,1-.33.38l-.71.28a4.54,4.54,0,0,1-4.2-3.68l.05-.47c.06-.16.11-.32.16-.49s.1-.36.17-.55a13.61,13.61,0,0,1,.44-1.32,3.68,3.68,0,0,1,.78-1.18,11.17,11.17,0,0,1,.43-1.06c.22-.49.6-1.22,1.13-2.19l1-1.8c.25-.44.45-.78.61-1a6.44,6.44,0,0,0-1.13-1.37c-.41-.79-.76-1.54-1.06-2.27a17.88,17.88,0,0,1-.69-1.93,6.4,6.4,0,0,0-.14-1c-.06-.28-.12-.58-.19-.9s-.17-.69-.23-1a5.52,5.52,0,0,1-.1-1.09,1.57,1.57,0,0,1-.28-.66l.09-.47a1.55,1.55,0,0,0,0-.88c-.06-.36-.14-.73-.23-1.1s-.14-.67-.22-1a4,4,0,0,1-.07-1.14,2.82,2.82,0,0,1,.31-1.06,2.26,2.26,0,0,1,.87-.87l.8,0,.83.45q.4.21.78.45l1,.47a8.09,8.09,0,0,1,1,.61l.33.67.61.51v.52a2.34,2.34,0,0,1,.05.52c0,.41.06.66.19.76l.19.56a5.57,5.57,0,0,0,.14,1.25c.09.4.19.77.28,1.11s.19.71.29,1.09a3.14,3.14,0,0,1,0,1.23,2.24,2.24,0,0,0,.48-.33.6.6,0,0,1,.18-.15.49.49,0,0,0,.19-.14l2.79-3.77-.1-.48,1-.94.73-.71a3.18,3.18,0,0,0,.59-.7l.52-.38a6.45,6.45,0,0,1,4.3-2.93l.66-.09.19.61a2,2,0,0,0,.78.95,14.07,14.07,0,0,0,1.25.8l.42.28a1.81,1.81,0,0,1,.24.71,1.73,1.73,0,0,1,0,.42l.19.48a4.09,4.09,0,0,1-.92,1.65c-.36.34-.72.66-1.06.94l-.78.68a2,2,0,0,0-.54.78l-.33.38a2.57,2.57,0,0,0-1.28,1.51l-.14.57h-.57s-.1,0-.21.16a3.55,3.55,0,0,0-.49.83,5.58,5.58,0,0,1-.48.61l-.23.24a2.06,2.06,0,0,1-.12.35c0,.11-.1.25-.17.4a4.16,4.16,0,0,0-.75.92l-.33.69c-.13.25-.24.49-.36.73a2.73,2.73,0,0,1-.54.73Z",
    transform: "translate(171.23 0.98)",
    style: {
      fill: "#004aae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.52,153.4c-.07,1.19-.13,2.39-.19,3.58a26.9,26.9,0,0,0,0,3.12,6.08,6.08,0,0,0-.12.87c0,.3,0,.59-.07.87v.57a2.65,2.65,0,0,1,0,.57l-1,.14.34,1.46-.52.57-.19.85a18.21,18.21,0,0,1-2.5,8.68l-.38.66c-.54.72-1.07,1.5-1.61,2.33s-1.14,1.73-1.84,2.67c-1.1,1.2-2.06,2.21-2.9,3a14.44,14.44,0,0,1-2.52,2.06l-.43.52c-.59.56-1.11,1-1.53,1.39s-.81.71-1.16,1.06l-.94.85a5,5,0,0,1-.85.61,1.63,1.63,0,0,0-1.27-.35l-1,.21a1.57,1.57,0,0,1-.57-1,4.52,4.52,0,0,1,.19-1.16c.09-.44.18-.93.26-1.46a3.38,3.38,0,0,0-.26-1.75,8.88,8.88,0,0,0,.4-1c.11-.34.23-.72.35-1.13a7,7,0,0,1,.33-.83,2.08,2.08,0,0,1,.31-.42,4.29,4.29,0,0,1,.38-.33,3.06,3.06,0,0,0,.49-.54,8.59,8.59,0,0,0,2.17-1.35,16.11,16.11,0,0,0,2.1-2,18.29,18.29,0,0,0,1.7-2.26,9.89,9.89,0,0,0,1.06-2.15l.29-.85,1.65-2.12.09-1.32a25.39,25.39,0,0,0,1.84-5.48,15.69,15.69,0,0,0,.45-3.7,33.41,33.41,0,0,0-.82-7.71,34.52,34.52,0,0,0-.95-3.36,1.87,1.87,0,0,0,.26-.73c.08-.36.14-.74.19-1.15s.08-.8.09-1.16a1.86,1.86,0,0,0-.07-.78l-.33-.47a.59.59,0,0,1-.23-.35c0-.14-.07-.29-.1-.45a3.54,3.54,0,0,1,.62-2.27,9.88,9.88,0,0,1,1.72.45c.55.21,1.08.42,1.58.64a8.2,8.2,0,0,0,1.11,1.84l1.15,1.37,1,1.2a9.43,9.43,0,0,1,1,1.53c.13,1,.29,2,.48,2.84s.4,1.73.66,2.64Z",
    transform: "translate(171.23 0.98)",
    style: {
      fill: "#34b3f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.69,139.45v3.09h-6.45v3.34h4.83v3h-4.83v6.4h-3.85V139.45Z",
    transform: "translate(171.23 0.98)",
    style: {
      fill: "#34b3f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,139.45v3.09h-4.19v12.74H232V142.54h-4.19v-3.09Z",
    transform: "translate(171.23 0.98)",
    style: {
      fill: "#34b3f1"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFt);
export default __webpack_public_path__ + "static/media/MyFT.06ff22e5ce050032f054e41c78f1f23b.svg";
export { ForwardRef as ReactComponent };